<template>
  <div class="statistic">
    <a-layout style="background-color: black; position: relative">
      <a-layout-sider width="200" style="background: #fff">
        <h1 class="stationName">{{ stationName }}</h1>
        <a-menu
          theme="dark"
          mode="inline"
          style="height: 820px; border-right: none"
          v-model="defaultSelectedKeys"
          :default-open-keys="defaultOpenKeys"
        >
          <a-sub-menu v-for="s in sideMenus" :key="s.key">
            <span slot="title">{{ s.value }}</span>
            <a-menu-item
              v-for="c in s.children"
              :key="c.code"
              @click="render(c)"
            >
              <span :style="{ backgroundColor: computedColor(c) }" style="position: absolute; left: 18px" class="icon"></span>
              {{ c.name }}
            </a-menu-item>
          </a-sub-menu>
        </a-menu>
      </a-layout-sider>
      <a-layout>
        <a-layout-content style="background-color: #2F3D4F; padding: 20px; min-height: 280px">
          <transition name="bounce" enter-active-class="animate__animated animate__zoomIn" leave-active-class="animate__animated animate__zoomOut">
            <div v-show="promptVisible" class="prompt">
              <div class="head">
                <a-icon @click="promptVisible = false" type="close" class="icon" style="position: absolute; right: 20px;" />
              </div>
              <div class="title">{{ $t('station.colors') }}</div>
              <div>
                <div v-for="(value, key) in runningStatus" :key="key" style="height: 100%; display: flex; align-items: center; margin: 10px">
                  <span class="box" :style="{ backgroundColor: value.color }"></span>
                  <span style="color: #fff; margin-left: 5px; font-size: 16px">{{value.label}}</span>
                </div>
              </div>
            </div>
          </transition>
          <div class="header">
            <div class="img">
              <img :src="url" />
            </div>
            <div class="input">
              <el-date-picker
                type="daterange"
                align="right"
                style="background-color: #2f3d4f;"
                unlink-panels
                v-model="outerDateValue"
                :key="lang"
                :picker-options="pickerOptions"
              />
              <button v-if="buttonsShow['device:manage:device:history:query']" :class="{ disabled }" :disabled="disabled" class="search" @click="render()">{{ $t('buttons.search') }}</button>
              <button :class="{ disabled }" :disabled="disabled" class="export" @click="exportExcel">{{ $t('buttons.export') }}</button>
              <button :class="{ disabled }" :disabled="disabled" @click="openDeviceCompareModal">{{ $t('station.dc') }}</button>
              <button v-if="isFlowmeterShow" :class="{ disabled }" :disabled="disabled" @click="initialAvgConsumptionChart">{{ $t('buttons.comparisonOfGasElectricityRatio') }}</button>
              <button :class="{ disabled }" :disabled="disabled" @click="initialDeviceTChart">{{ $t('buttons.time') }}</button>
              <button v-if="buttonsShow['device:manage:device:history:delete']" :class="{ disabled }" :disabled="disabled" @click="showRemoveHistroyDataConfirm">{{ $t('buttons.history') }}</button>
              <!-- 数据连续显示 -->
              <!-- <label>{{ $t('device.Continuous') }}</label>
              <a-switch
                style="margin-top: -3px"
                v-model="completeState"
                :checked-children="$t('common.yes')"
                :un-checked-children="$t('common.no')"
                @change="handleDataShowModalChange"
              /> -->
            </div>
            <div class="exportData">
            <label>{{ $t('device.exportP') }}</label>
            <a-switch
              style="margin-top: -3px"
              v-model="exportType"
              :checked-children="$t('common.yes')"
              :un-checked-children="$t('common.no')"
            />
              <label>{{ $t('device.exportI') }}</label>
              <a-select
                dropdownClassName="selectOption"
                :style="`width: ${ lang === 'en' ? '110' : '80' }px; margin-right: 10px`"
                v-model="unit"
                @change="handleUnitChange"
              >
                <a-select-option value="s">
                  {{ $t('common.second') }}
                </a-select-option>
                <a-select-option value="m">
                  {{ $t('common.minute') }}
                </a-select-option>
                <a-select-option value="h">
                  {{ $t('common.hour') }}
                </a-select-option>
              </a-select>
              <a-select
                dropdownClassName="selectOption"
                style="width: 80px"
                v-model="num"
              >
                <a-select-option v-for="o in options" :key="o" :value="o">
                  {{ o }}
                </a-select-option>
              </a-select>
              <a-button
                type="primary"
                @click="showRateMask"
              >
                {{ $t('device.count') }}
              </a-button>
              <a-button
                type="primary"
                v-show="rateInterval && buttonsShow['device:manage:samplingRate:query']"
                @click="setRate(false)"
              >
                {{ defaultRate }}
              </a-button>
              <a-button
                type="primary"
                v-show="deviceType === 'DB'"
                @click="setLoadRateInfoAndShowLoadRateModal"
                :loading="loadRateModalButtonLoading"
              >
                {{ $t('device.loadRateCalculation') }}
              </a-button>
            </div>
            <a-icon @click="showPrompt" type="question-circle" style="position: absolute; right: 0; top: 0; color: #fff; font-size: 26px; cursor: pointer" />
            <ul class="pointsList" v-if="isContentShow">
              <li
                v-for="(item, index) in points"
                :key="index"
              >
                <label :for="item.code">
                  <input
                    type="checkbox"
                    style="margin-right: 10px"
                    :id="item.code"
                    :checked="item.checked"
                    @change="handlePointCheckedChange($event, item)"
                  />
                  {{ item[lang] }} ({{ item.unit }})
                </label>
              </li>
              <li v-if="buttonsShow['query:gk:flow']" v-show="deviceType === 'LLJ'" @contextmenu="handleC">
                <label for="extra" style="width: 100%; height: 100%; display: flex; align-items: center">
                  <input
                    id="extra"
                    ref="extra"
                    type="checkbox"
                    style="margin-right: 10px"
                    :checked="isExtrachecked"
                    @change="handleExtraChange"
                  />
                  {{ $t('station.wf') }}(m³/min)
                </label>
              </li>
            </ul>
          </div>
          <a-spin size="large" style="position:absolute; left: 50%; transform: translateX(-50%)" v-show="!isChartsShow" />
          <div class="container" v-show="isChartsShow">
            <ul class="charts">
              <li>
                <h3>
                  {{ $t('device.summary') }}
                  <a-button style="position: absolute; background-color: rgb(47, 61, 79); color: #fff; border-bottom: none; z-index: 10; right: 20px;" @click="isParameterSettingVisible = true">
                    {{ $t('device.axis') }}
                  </a-button>
                </h3>
                <hr />
                <div id="summary"></div>
              </li>
              <li
                v-for="(item, index) in points"
                :key="item.code"
                v-show="item.checked"
              >
                <h3>
                  {{ item[lang] }}
                  <a-button style="float: right; background-color: rgb(47, 61, 79); color: #fff; border-bottom: none; z-index: 1" @click="openRangeMask(item, index)">
                    {{ $t('device.distribution') }}
                  </a-button>
                </h3>
                <hr />
                <div :id="item.name"></div>
              </li>
            </ul>
          </div>
        </a-layout-content>
      </a-layout>
    </a-layout>
    <div class="mask statistics" v-show="deviceCompareVisible">
      <div class="wrapper">
        <div class="container">
          <a-icon type="close" @click="closeDeviceCompareModal" />
          <div class="content">
            <div class="form">
              <div>
                <!-- <ul class="inner-device-list">
                  <li :class="{ active: item.selected }" ></li>
                </ul> -->
              </div>
              <div style="display: flex;">
                <el-date-picker
                  :key="lang"
                  v-model="innerDate"
                  type="daterange"
                  align="right"
                  unlink-panels
                  :picker-options="pickerOptions"
                  style="background-color: #2f3d4f"
                  @change="onInnerDateChange"
                />
                <div style="position: relative; margin-left: 30px;">
                  <a-select v-model="deviceToCompare" :placeholder="$t('placeholder.device')" dropdownClassName="selectOption" style="width: 280px;">
                    <a-select-option v-for="item in deviceList" :key="item.code" @click="setActiveInnerDevice(item)">{{item.name}}</a-select-option>
                  </a-select>
                  <div class="explain">{{ $t("device.diff") }}</div>
                </div>
                <label style="display: flex; align-items: center; margin-left: 20px">
                  <span>{{ $t("device.axis") }}: </span>
                  <a-input v-model="yAxis.min" style="width: 166px; margin: 0 15px;" :placeholder="$t('device.enterMinAxis')"></a-input>
                  <a-input v-model="yAxis.max" style="width: 166px; margin-right: 15px;" :placeholder="$t('device.enterMaxAxis')"></a-input>
                  <a-button type="primary" style="margin-right: 10px;" @click="setDeviceComparationData">{{ $t("dataReport.compare") }}</a-button>
                  <a-button type="primary" @click="clearDevcieComperationChart">{{ $t("device.clearCharts") }}</a-button>
                </label>
              </div>
              <ul
                class="dataList"
                style="margin-left: 0; margin-top: 0; overflow: hidden; width: 100%"
              >
                <template v-if="comparationDeviceCode">
                  <li v-for="item in deviceComparationPoints" :key="comparationDeviceCode + item.code">
                    <label :for="comparationDeviceCode + item.code">
                      <input
                        type="checkbox"
                        :checked="item.checked"
                        :value="item.code"
                        :id="comparationDeviceCode + item.code"
                        @change="handleInnerChange($event, comparationDeviceCode, item)"
                        style="margin-right: 10px; margin-top: 2px"
                      />
                      {{ item[lang] }} ({{ item.unit }})
                    </label>
                  </li>
                </template>
              </ul>
            </div>
            <div id="deviceComparation"></div>
          </div>
        </div>
        <a-spin size="large" v-show="deviceCompareLoading" style="left: 50%; transform: translateX(-50%);" />
      </div>
    </div>
    <div class="mask statistics avgConsumption" v-show="avgConsumptionVisible">
      <div class="wrapper">
        <div class="container">
          <a-icon type="close" @click="closeAvgConsumptionMask" />
          <div class="box">
            <a-button type="primary" style="margin-bottom: 10px" @click="addRange">{{ $t('device.addRange') }}</a-button>
            <a-button type="primary" style="margin: 0 10px 10px" @click="renderChart" v-show="removeBtnShow">{{ $t('device.analysis') }}</a-button>
            <a-button type="primary" style="margin-bottom: 10px;" @click="removeRange" v-show="removeBtnShow">{{ $t('buttons.goBack') }}</a-button>
            <ul>
              <li v-for="(range, index) in ranges" :key="range.id">
                <a-checkbox v-model="range.checked" :id="range.id" />
                <label :for="range.id">{{ $t('device.range') }}{{ index + 1 }}：</label>
                <el-date-picker
                  style="width: 140px; margin-left: 25px;"
                  type="date"
                  :placeholder="$t('device.selectDate')"
                  v-model="range.date"
                />
                <div class="time_wrapper">
                  <el-time-select
                    style="margin-left: 10px"
                    :picker-options="{
                      start: '01:00',
                      step: '01:00',
                      end: '24:00'
                    }"
                    :placeholder="$t('device.selectTime')"
                    v-model="range.startTime"
                  />
                  <span style="color: #fff; margin: 0 8px">-</span>
                  <el-time-select
                    :picker-options="{
                      start: '01:00',
                      step: '01:00',
                      end: '24:00'
                    }"
                    :placeholder="$t('device.selectTime')"
                    v-model="range.endTime"
                  />
                </div>
                <a-select mode="tags" style="width: 52%; margin-left: 20px; height: auto" :placeholder="$t('placeholder.device')" v-model="range.deviceCode">
                  <a-select-option v-for="device in FOE" :key="device.code">
                    {{ device.name }}
                  </a-select-option>
                </a-select>
              </li>
            </ul>
          </div>
          <div class="chart"></div>
        </div>
      </div>
    </div>
    <div class="mask time" v-show="timeShow">
      <div class="wrapper">
        <div class="container">
          <a-icon type="close" @click="closTime" />
          <div class="head">
            <h2 style="color: #fff">
              {{stationName}} - {{deviceName}}
              <a-select v-model="timeDevice" style="width: 200px; margin-left: 15px">
                <a-select-option v-for="data in points" :key="data.code" :value="data.code">
                  {{ data.name }}
                </a-select-option>
              </a-select>
              <a-button type="primary" @click="addTimeRange" style="margin-left: 15px">{{ $t('device.addRange') }}</a-button>
              <a-button type="primary" style="margin: 0 15px" @click="timeAnalyse" :loading="tLoading">{{ $t('device.analysis') }}</a-button>
              <a-button type="primary" @click="timeGoBack">{{ $t('buttons.goBack') }}</a-button>
            </h2>
          </div>
          <div class="box">
            <ul style="overflow: hidden">
              <li v-for="(range, i) in timeRanges" :key="range.id">
                <label style="display: inline-block; width: 66px">{{ $t('device.range') }}{{i + 1}}：</label>
                <el-date-picker
                  v-model="range.dateRange"
                  type="daterange"
                  align="right"
                  unlink-panels
                  :picker-options="pickerOptions"
                  style="background-color: #2f3d4f;"
                  @change="changeTime($event, i)"
                />
              </li>
            </ul>
            <div class="content">
              <div class="chart" id="time"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <a-modal v-model="isRemoveHistroyDataConfirm" :title="$t('confirm')" @ok="removeHistroyData">
      <a-form-model class="removeModal">
        <a-form-model-item :label="$t('placeholder.timeRange')">
          <a-range-picker
            v-model="removeTimeRange"
            style="width: 100%;"
            :show-time="{ format: 'HH:mm:ss' }"
            format="YYYY-MM-DD HH:mm:ss"
            :placeholder="[$t('common.startTime'), $t('common.endTime')]"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <div ref="range" class="mask range" v-show="rangeShow">
      <div class="wrapper" @mousedown="handleMouseDown">
        <div class="container" style="padding-bottom: 20px">
          <a-icon :type="shrink ? 'arrows-alt' : 'shrink'" style="right: 50px" @click="setShrink" />
          <a-icon type="close" @click="closeRangeMask"  @mousedown.stop="" />
          <div class="head" @mousedown.stop="">
            <h2 style="color: #fff">
              {{stationName}} - {{deviceName}} - {{dataPointName}}
              <el-date-picker
                v-model="rangeDateValue"
                type="daterange"
                align="right"
                unlink-panels
                :picker-options="pickerOptions"
                style="background-color: #2f3d4f; margin: 0 20px"
                @change="onRangeDateChange"
              />
              <a-button type="primary" @click="addDataRange">{{ $t('device.addRange') }}</a-button>
              <a-button type="primary" style="margin: 0 15px" @click="analyse" v-show="dataRanges.length > 0" :loading="isLoading">{{ $t('device.analysis') }}</a-button>
              <a-button type="primary" @click="goBack" v-show="dataRanges.length > 0">{{ $t('buttons.goBack') }}</a-button>
            </h2>
          </div>
          <div class="box" @mousedown.stop="">
            <ul style="overflow: hidden; margin: 20px 0">
              <li v-for="(item, i) in dataRanges" :key="item.id" class="formList">
                <a-input style="color: #fff; width: 25%" v-model="item.min" />
                <span style="color: #fff">≤</span>
                <div>
                  <label style="display: inline-block; margin-right: 10px">{{ $t('device.range') }}{{ i + 1 }}：</label>
                </div>
                <span style="color: #fff">＜</span>
                <a-input style="color: #fff; width: 25%" v-model="item.max" />
              </li>
            </ul>
            <div class="content">
              <div class="detail">
                <h3>{{ $t('device.distributionD') }}</h3>
                <ul>
                  <li v-for="(value, key) in dataRangeDetail" :key="key"><span>{{ key }}: </span><span style="font-size: 18px">{{value}}</span></li>
                </ul>
                <a-button type="primary" @click="renderRangesChart">{{ $t('device.chart') }}</a-button>
              </div>
              <div class="chart" id="ranges"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mask rate" v-show="rateShow">
      <div class="wrapper">
        <div class="container">
          <a-icon type="close" @click="closRate" />
          <div class="head">
            <h2 style="color: #fff">
              {{ deviceName }}
              <br />
              <label>{{ $t('history.dateRange') }}</label>
              <el-date-picker
                v-model="rateDateRange"
                type="datetimerange"
                align="right"
                unlink-panels
                :picker-options="pickerOptions"
                style="background-color: #2f3d4f; margin: 20px 15px 20px 0"
              />
              <a-button type="primary" @click="saveTime">{{ $t('buttons.save') }}</a-button>
              <br />
              <label style="margin-bottom: 20px">{{ $t('device.acquisitionInterval') }}</label>
              <a-select dropdownClassName="selectOption" style="width: 100px; margin-bottom: 20px" v-model="rateInterval">
                <a-select-option value="10">10</a-select-option>
                <a-select-option value="20">20</a-select-option>
                <a-select-option value="30">30</a-select-option>
                <a-select-option value="60">60</a-select-option>
                <a-select-option value="180">180</a-select-option>
                <a-select-option value="300">300</a-select-option>
                <a-select-option value="600">600</a-select-option>
              </a-select>
              <span style="margin-left: 10px; font-size: 16px">{{ $t('common.second') }}</span>
              <br />
              <a-button :loading="isRateLoading" type="primary" style="margin-bottom: 20px" @click="setRate">{{ $t('history.calculate') }}</a-button>
              <br />
              {{ $t('device.expection') }}{{ rateTarget }}
              <br />
              {{ $t('device.real') }}{{ rateResult }}
              <br />
              {{ $t('device.rate') }}{{ rate }}
            </h2>
          </div>
        </div>
      </div>
    </div>
    <div class="mask loadRate" v-show="loadRateShow">
      <div class="wrapper">
        <div class="container">
          <a-icon type="close" @click="closeLoadRateModalAndClearInfo" />
          <div class="head">
            <h2 style="color: #fff">
              {{ stationName }} - {{ deviceName }}
              <br />
            </h2>
            <a-menu v-model="loadRateType" mode="horizontal" style="background-color: #2f3d4f; margin-bottom: 15px; color: #fff; font-size: 16px">
              <a-menu-item key="IndustrialFrequency" style="margin-right: 15px" @click="setLoadRateForm">{{ $t('device.IndustrialFrequency') }}</a-menu-item>
              <a-menu-item key="variableFrequency" @click="setLoadRateForm">{{ $t('device.variableFrequency') }}</a-menu-item>
            </a-menu>
          </div>
          <div class="box">
            <div class="left">
              <div class="form">
                <a-form-model ref="loadRateForm" layout="inline" style="margin-top: 15px;" :model="loadRateForm" :rules="loadRateRules">
                  <a-form-model-item required :label="$t('device.dateRange')" style="margin-bottom: 8px;" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
                    <el-date-picker
                      type="datetimerange"
                      align="right"
                      unlink-panels
                      v-model="loadRateDateRange"
                      :key="lang"
                      @change="validateDate"
                    />
                  </a-form-model-item>
                  <br />
                  <div class="flex">
                    <a-form-model-item style="margin-right: 60px; position: relative" v-if="loadRateType[0] === 'IndustrialFrequency'" :label="$t('device.unloadingPower') + '(kW)'" :label-col="{ span: 10 }" :wrapper-col="{ span: 14 }" prop="unloadingPower">
                      <a-input v-model="loadRateForm.unloadingPower" style="background-color: #2f3d4f; color: #fff; width: 70%" />
                      <a-button type="primary" style="position: absolute; left: 110%; top: 50%; transform: translateY(-50%)" @click="saveLoadRateSettings('unloadingPower', 'enterUnloadingPower')" :loading="isunloadingPowerSaving">{{ $t('buttons.save') }}</a-button>
                    </a-form-model-item>
                    <a-form-model-item style="position: relative; margin-right: 60px" :label="$t('device.fullLoadPower') + '(kW)'" :label-col="{ span: 10 }" :wrapper-col="{ span: 14 }" prop="fullLoadPower" v-if="loadRateType[0] === 'variableFrequency'">
                      <a-input v-model="loadRateForm.fullLoadPower" style="background-color: #2f3d4f; color: #fff; width: 70%" />
                      <a-button type="primary" style="position: absolute; left: 110%; top: 50%; transform: translateY(-50%)" @click="saveLoadRateSettings('fullLoadPower', 'enterFullLoadPower')" :loading="isfullLoadPowerSaving">{{ $t('buttons.save') }}</a-button>
                    </a-form-model-item>
                    <a-form-model-item :label="$t('device.stanbyPower') + '(kW)'" :label-col="{ span: 11 }" :wrapper-col="{ span: 13 }" prop="stanbyPower">
                      <a-input v-model="loadRateForm.stanbyPower" style="background-color: #2f3d4f; color: #fff; width: 70%" />
                      <a-button type="primary" style="position: absolute; left: 110%; top: 50%; transform: translateY(-50%)" @click="saveLoadRateSettings('stanbyPower', 'enterStanbyPower')" :loading="isstanbyPowerSaving">{{ $t('buttons.save') }}</a-button>
                    </a-form-model-item>
                  </div>
                </a-form-model>
                <header style="margin-top: 5px;">
                  <label style="margin-left: 0;">{{ $t('station.ds') }}: </label>
                  <!-- <a-button type="primary" style="margin-left: 10px;" @click="saveDevices" :loading="isDeviceSaving">{{ $t('buttons.save') }}</a-button> -->
                </header>
                <div class="paramGroups">
                  <!-- <div class="paramGroup" v-for="d in deviceList" :key="d.id">
                    <a-checkbox/>
                    <label>{{ d.name }}</label>
                  </div> -->
                  <a-radio-group style="width: 100%;" v-model="selectedDevices" v-if="loadRateType[0] === 'variableFrequency'">
                    <a-row>
                      <a-col :span="8" v-for="d in deviceList" :key="d.id">
                        <a-radio :value="d.id">
                          {{ d.name }}
                        </a-radio>
                      </a-col>
                    </a-row>
                  </a-radio-group>
                  <a-radio-group v-else style="width: 100%;" v-model="selectedDevice">
                    <a-row>
                      <a-col :span="8" v-for="d in deviceList" :key="d.id">
                        <a-radio  :value="d.id">
                          {{ d.name }}
                        </a-radio>
                      </a-col>
                    </a-row>
                  </a-radio-group>
                </div>
              </div>
              <div class="result">
                <header style="margin-top: 5px;">
                  <label style="margin-left: 0;">{{ $t('device.result') }}: </label>
                  <a-button type="primary" style="margin-left: 10px;" @click="getLoadRate" :loading="isGettingLoadRateButtonLoading">{{ $t('history.calculate') }}</a-button>
                </header>
                <div class="content">
                  <template v-if="loadRateType[0] === 'IndustrialFrequency'">
                    <div>
                      <label>{{ $t('device.dataCount') }}: </label>
                      <span class="data">{{ dataCount }}</span>
                    </div>
                    <div>
                      <label>{{ $t('device.loadCount') }}: </label>
                      <span class="data">{{ loadCount }}</span>
                    </div>
                    <div>
                      <label>{{ $t('device.unloadCount') }}: </label>
                      <span class="data">{{ unloadCount }}</span>
                    </div>
                  </template>
                  <div v-if="loadRateType[0] === 'variableFrequency'">
                    <label>{{ $t('station.aPower') }}: </label>
                    <span class="data">{{ avgPower }} kW</span>
                  </div>
                  <div>
                    <label>{{ $t('device.electricityMeterAccumulation') }}: </label>
                    <span class="data">{{ electricityMeterAccumulation }} kW·H</span>
                  </div>
                  <template v-if="loadRateType[0] === 'variableFrequency'">
                    <div>
                      <label>{{ $t('device.maxPower') }}: </label>
                      <span class="data">{{ maxPower }} kW</span>
                    </div>
                    <div>
                      <label>{{ $t('device.minPower') }}: </label>
                      <span class="data">{{ minPower }} kW</span>
                    </div>
                  </template>
                  <div v-if="loadRateType[0] === 'IndustrialFrequency'">
                    <label>{{ $t('device.loadingRate') }}: </label>
                    <span class="data">{{ loadingRate }} %</span>
                  </div>
                  <div v-if="loadRateType[0] === 'variableFrequency'">
                    <label>{{ $t('device.capacityRate') }}: </label>
                    <span class="data">{{ capacityRate }} %</span>
                  </div>
                  <template v-if="loadRateType[0] === 'IndustrialFrequency'">
                    <div>
                      <label>{{ $t('device.unloadRate') }}: </label>
                      <span class="data">{{ unloadRate }} %</span>
                    </div>
                    <div>
                      <label>{{ $t('station.aPower') }}: </label>
                      <span class="data">{{ avgPower }} kW</span>
                    </div>
                    <div>
                      <label>{{ $t('device.maxPower') }}: </label>
                      <span class="data">{{ maxPower }} kW</span>
                    </div>
                    <div>
                      <label>{{ $t('device.minPower') }}: </label>
                      <span class="data">{{ minPower }} kW</span>
                    </div>
                  </template>
                </div>
              </div>
            </div>
            <div class="right">
              <header>
                <label style="margin-left: 0; font-size: 18px">{{ $t('dataReport.calculation') }}: </label>
              </header>
              <div style="display: flex; flex-direction: column; justify-content: space-between; height: 94.5%">
                <section>
                  <label>{{ $t('device.dateRange') }}: </label>
                  <span>{{ $t('device.description.dateRange') }}</span>
                  <br>
                  <label>{{ $t('device.unloadingPower') }}: </label>
                  <span>{{ $t('device.description.unloadingPower') }}</span>
                  <br>
                  <label>{{ $t('device.fullLoadPower') }}: </label>
                  <span>{{ $t('device.description.fullLoadPower') }}</span>
                  <br>
                  <label>{{ $t('device.stanbyPower') }}: </label>
                  <span>{{ $t('device.description.stanbyPower') }}</span>
                  <br>
                </section>
                <section style="margin-top: 20px;">
                  <label>{{ $t('station.aPower') }}=</label>
                  <span>{{ $t('device.description.aPower') }}</span>
                  <br>
                  <label>{{ $t('device.electricityMeterAccumulation') }}=</label>
                  <span>{{ $t('device.description.electricityMeterAccumulation') }}</span>
                  <br>
                  <label>{{ $t('device.maxPower') }}=</label>
                  <span>{{ $t('device.description.maxPower') }}</span>
                  <br>
                  <label>{{ $t('device.minPower') }}=</label>
                  <span>{{ $t('device.description.minPower') }}</span>
                  <br>
                  <label>{{ $t('device.loadingRate') }}=</label>
                  <span>{{ $t('device.description.loadingRate') }}</span>
                  <br>
                  <label>{{ $t('device.capacityRate') }}=</label>
                  <span>{{ $t('device.description.capacityRate') }}</span>
                  <br>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mask axis" v-show="isParameterSettingVisible">
      <div class="wrapper">
        <div class="container">
          <a-icon type="close" @click="closeParameterSetting" />
          <div class="content">
            <header>
              <a-button type="primary" @click="addParameter">{{ $t("buttons.addParam") }}</a-button>
            </header>
            <ul class="parameters" style="margin-top: 12px;">
              <li
                v-for="(p, i) in parametersAxisSettings"
                :key="p.id"
              >
                <label style="margin-left: 0;">{{ $t("configuration.parameter") }}{{ i + 1 }}: </label>
                <a-select v-model="p.selectedPoints" mode="multiple" dropdownClassName="selectOption" style="width: 400px; margin: 0 10px;" :placeholder="$t('device.selectPoints')">
                  <a-select-option
                    v-for="p in points"
                    :key="p.code"
                  >
                    {{ p[lang] }}
                  </a-select-option>
                </a-select>
                <a-input v-model="p.min" style="width: 166px; margin-right: 10px;" :placeholder="$t('device.enterMinAxis')"></a-input>
                <a-input v-model="p.max" style="width: 166px;" :placeholder="$t('device.enterMaxAxis')"></a-input>
                <i @click="deleteParameterSetting(i)">
                  <svg t="1765332838466" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1818" width="24" height="30"><path d="M607.897867 768.043004c-17.717453 0-31.994625-14.277171-31.994625-31.994625L575.903242 383.935495c0-17.717453 14.277171-31.994625 31.994625-31.994625s31.994625 14.277171 31.994625 31.994625l0 351.94087C639.892491 753.593818 625.61532 768.043004 607.897867 768.043004z" fill="#ccc" p-id="1819"></path><path d="M415.930119 768.043004c-17.717453 0-31.994625-14.277171-31.994625-31.994625L383.935495 383.935495c0-17.717453 14.277171-31.994625 31.994625-31.994625 17.717453 0 31.994625 14.277171 31.994625 31.994625l0 351.94087C447.924744 753.593818 433.647573 768.043004 415.930119 768.043004z" fill="#ccc" p-id="1820"></path><path d="M928.016126 223.962372l-159.973123 0L768.043004 159.973123c0-52.980346-42.659499-95.983874-95.295817-95.983874L351.94087 63.989249c-52.980346 0-95.983874 43.003528-95.983874 95.983874l0 63.989249-159.973123 0c-17.717453 0-31.994625 14.277171-31.994625 31.994625s14.277171 31.994625 31.994625 31.994625l832.032253 0c17.717453 0 31.994625-14.277171 31.994625-31.994625S945.73358 223.962372 928.016126 223.962372zM319.946246 159.973123c0-17.545439 14.449185-31.994625 31.994625-31.994625l320.806316 0c17.545439 0 31.306568 14.105157 31.306568 31.994625l0 63.989249L319.946246 223.962372 319.946246 159.973123 319.946246 159.973123z" fill="#ccc" p-id="1821"></path><path d="M736.048379 960.010751 288.123635 960.010751c-52.980346 0-95.983874-43.003528-95.983874-95.983874L192.139761 383.591466c0-17.717453 14.277171-31.994625 31.994625-31.994625s31.994625 14.277171 31.994625 31.994625l0 480.435411c0 17.717453 14.449185 31.994625 31.994625 31.994625l448.096758 0c17.717453 0 31.994625-14.277171 31.994625-31.994625L768.215018 384.795565c0-17.717453 14.277171-31.994625 31.994625-31.994625s31.994625 14.277171 31.994625 31.994625l0 479.231312C832.032253 916.835209 789.028725 960.010751 736.048379 960.010751z" fill="#ccc" p-id="1822"></path></svg>
                </i>
              </li>
            </ul>
          </div>
        </div>
        <footer>
          <div class="buttons">
            <a-button @click="closeParameterSetting">{{ $t("common.cancelText") }}</a-button>
            <a-button type="primary" style="margin-left: 12px;" @click="confirmAxisSetting">{{ $t("common.okText") }}</a-button>
          </div>
        </footer>
      </div>
    </div>
    <a-modal
      v-model="extraFlowShow"
      :title="$t('station.wf')"
      :confirm-loading="isFlowLoading"
      :width="lang === 'en' ? 660 : 520"
      @ok="confirmExtraForm"
      @close="clearFlowForm"
    >
      <a-form-model
        style="padding-right: 12px"
        :label-col="lang === 'en' ? { span: 7 } : { span: 5 }"
        :wrapper-col="lang === 'en' ? { span: 17 } : { span: 19 }"
      >
        <a-form-model-item :label="$t('station.sdt')">
          <a-select v-model="flowForm.id">
            <a-select-option
              v-for="d in deviceList"
              :key="d.id"
              @click.native="selectDeviceForFlow(d)"
            >
              {{ d.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item :label="$t('station.spt')" v-show="flowForm.id">
          <a-select v-show="!flowForm.tMock" v-model="flowForm.pointCode" style="width: 80%" @change="clearGkll">
            <a-select-option
              v-for="f in flowPointsList"
              :key="f.code"
            >
              {{ f[lang] }}
            </a-select-option>
          </a-select>
          <a-input :placeholder="$t('station.eav')" v-show="flowForm.tMock" style="width: 80%; background-color: #fff; color: #666;" v-model="flowForm.tValue" />
          <a-checkbox v-model="flowForm.tMock" style="color: #666; float: right; font-size: 14px" @change="clearGkll">
            {{ $t('station.analog') }}
          </a-checkbox>
        </a-form-model-item>
        <a-form-model-item :label="$t('station.spp')">
          <a-select v-model="flowForm.pid">
            <a-select-option
              v-for="d in deviceList"
              :key="d.id"
              @click.native="selectPDeviceForFlow(d)"
            >
              {{ d.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="压力参数选择" v-show="flowForm.pid">
          <a-select v-show="!flowForm.pMock" v-model="flowForm.pPointCode" style="width: 80%" @change="clearGkll">
            <a-select-option
              v-for="f in pressurePointsList"
              :key="f.code"
            >
              {{ f.name }}
            </a-select-option>
          </a-select>
          <a-input :placeholder="$t('station.eav')" v-show="flowForm.pMock" style="width: 80%; background-color: #fff; color: #666;" v-model="flowForm.pValue" />
          <a-checkbox v-model="flowForm.pMock" style="color: #666; float: right; font-size: 14px" @change="clearGkll">
            {{ $t('station.analog') }}
          </a-checkbox>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
const deviceTypeMap = {}

import * as XLSX from '@/plugins/export-excel'
import url from '@/assets/product.png'
import formatDate from '@/components/function/formatDate'
import moment from 'moment'
// import completeData from '@/components/function/completeData'
import {
  getDeviceGroup,
  getDeviceHistoryData,
  getDayReport,
  deleteDeviceHistoryData
} from '@/api/device'
import { getDict } from '@/api/dict'
import { getProtocol } from '@/api/protocol'
import { nanoid } from 'nanoid'
import {
  searchDeviceList
} from "@/api/device"
import { f, u } from '@/api/order'

export default {
  data() {
    return {
      stationName: '',
      defaultOpenKeys: [],
      defaultSelectedKeys: [],
      sideMenus: [],
      runningStatus: {
        online: {
          color: '#0eed24',
          label: '在线'
        },
        running: {
          color: '#0eed24',
          label: '运行'
        },
        maintain: {
          color: '#ff681c',
          label: '保养'
        },
        error: {
          color: '#e82127',
          label: '故障'
        },
        standby: {
          color: '#11d7f5',
          label: '停机'
        },
        sleep: {
          color: '#11d7f5',
          label: '休眠'
        },
        offline: {
          color: '#4d4d4d',
          label: '离线'
        },
        prepare: {
          color: '#4d4d4d',
          label: '备机'
        }
      },
      promptVisible: false,
      url,
      outerDateValue: null,
      buttonsShow: {},
      pickerOptions: {
        shortcuts: [
          {
            text: this.$t('station.tld'),
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: this.$t('station.tlw'),
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: this.$t('station.tlm'),
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 31)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      disabled: false,
      exportType: true,
      unit: 'm',
      num: 1,
      perSeconds: 60,
      options: [1, 5, 30],
      defaultRate: '',
      isContentShow: false,
      isChartsShow: false,
      points: [],
      deviceCompareVisible: false,
      innerDate: null,
      deviceList: [],
      comparationDeviceCode: '',
      deviceComparationParamsList: {},
      deviceCompareLoading: false,
      avgConsumptionVisible: false,
      ranges: [],
      FOE: [],
      timeShow: false,
      deviceName: '',
      timeDevice: '',
      tLoading: false,
      timeRanges: [],
      isRemoveHistroyDataConfirm: false,
      removeTimeRange: [],
      rangeShow: false,
      shrink: false,
      dataPointName: '',
      rangeDateValue: [],
      dataRanges: [],
      isLoading: false,
      dataRangeDetail: {},
      rateShow: false,
      rateDateRange: [],
      rateInterval: '',
      isRateLoading: false,
      rate: '',
      rateTarget: '',
      rateResult: '',
      deviceType: '',
      extraFlowShow: false,
      isFlowLoading: false,
      flowForm: {},
      flowPointsList: [],
      pressurePointsList: [],
      isExtrachecked: false,
      deviceToCompare: '',
      deviceComparationPoints: [],
      height: '0px',
      completeState: true,
      loadRateShow: false,
      deviceList: [],
      loadRateDateRange: [],
      loadRateModalButtonLoading: false,
      loadRateForm: {
        unloadingPower: '',
        fullLoadPower: '',
        stanbyPower: '1'
      },
      loadRateRules: {},
      parameters: [],
      avgPower: 0,
      electricityMeterAccumulation: 0,
      maxPower: 0,
      minPower: 0,
      loadingRate: 0,
      capacityRate: 0,
      pointsOfLoadRate: [],
      isGettingLoadRateButtonLoading: false,
      selectedDevices: undefined,
      selectedDevice: undefined,
      loadRateType: ['IndustrialFrequency'],
      dataCount: 0,
      loadCount: 0,
      unloadCount: 0,
      unloadRate: 0,
      isunloadingPowerSaving: false,
      isfullLoadPowerSaving: false,
      isstanbyPowerSaving: false,
      isDeviceSaving: false,
      isFlowmeterShow: false,
      isParameterSettingVisible: false,
      parametersAxisSettings: [],
      yAxis: {
        min: null,
        max: null
      }
    }
  },
  computed: {
    removeBtnShow() {
      return this.ranges.some(item => item.checked)
    },
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    rateInterval() {
      this.setRate(false)
    },
    lang: {
      immediate: true,
      handler() {
        this.translate()
      }
    }
  },
  created() {
    const now = new Date(new Date().toDateString())
    this.outerDateValue = [now, now]
    const authorities = this.getAuthorities('/equipment/list')
    for (let i = 0; i < authorities.length; i++) {
      this.buttonsShow[authorities[i].code] = true
    }
    this.connecting = false
    this.axisMap = {}
  },
  async mounted() {
    await this.setDeviceTypeAndStatusMap()
    await this.setMenu()
    const device = this.sideMenus[0].children[0]
    const r = JSON.parse(localStorage.getItem('statisticsTime'))
    if (r) {
      const t = localStorage.getItem('saveTime')
      if (t === moment(+new Date()).format('YYYY-MM-DD')) {
        this.rateDateRange = r.map(d => new Date(d))
      } else {
        localStorage.removeItem('saveTime')
        localStorage.removeItem('statisticsTime')
        this.rateDateRange = [new Date(+new Date() - 24 * 3600000), new Date()]
      }
    } else {
      this.rateDateRange = [new Date(+new Date() - 24 * 3600000), new Date()]
    }
    this.render(device)
    this.getMemo()
  },
  beforeDestroy() {
    if (this.webSocket) {
      this.webSocket.close()
      this.webSocket = null
    }
    if (this.hbpSenderTimer) {
      clearInterval(this.hbpSenderTimer)
      this.hbpSenderTimer = null
    }
    if (this.summaryChart) {
      window.removeEventListener('resize', this.summaryChart.resize)
      this.summaryChart.dispose()
      this.summaryChart = null
    }
    for (let i = 0; i < this.points.length; i++) {
      if (this[`charts${i}`]) {
        window.removeEventListener('resize', this[`charts${i}`].resize)
        this[`charts${i}`].dispose()
        this[`charts${i}`] = null
      }
    }
  },
  methods: {
    translate() {
      this.loadRateRules = {
        unloadingPower: [
          {
            required: true,
            message: this.$t('device.enterUnloadingPower'),
            trigger: 'blur'
          },
          {
            validator: this.validateNumber,
            trigger: 'blur'
          }
        ],
        fullLoadPower: [
          {
            required: true,
            message: this.$t('device.enterFullLoadPower'),
            trigger: 'blur'
          },
          {
            validator: this.validateNumber,
            trigger: 'blur'
          }
        ],
        stanbyPower: [
          {
            required: true,
            message: this.$t('device.enterStanbyPower'),
            trigger: 'blur'
          },
          {
            validator: this.validateNumber,
            trigger: 'blur'
          }
        ]
      }
      this.pickerOptions = {
        shortcuts: [
          {
            text: this.$t('station.tld'),
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: this.$t('station.tlw'),
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: this.$t('station.tlm'),
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 31)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      }
      this.setDeviceTypeAndStatusMap()
    },
    validateNumber(_, value, callback) {
      if (isNaN(+value)) {
        callback(new Error(this.$t('device.enterNumber')))
      } else {
        callback()
      }
    },
    async getMemo() {
      try {
        const { data } = await f()
        this.memo = data
      } catch(e) {
        console.log(e)
      }
    },
    setLoadRateForm({ key }) {
      if (this.memo[1][this.device.id]) {
        for (let k in this.memo[1][this.device.id][key]) {
          this.loadRateForm[k] = this.memo[1][this.device.id][key][k]
        }
        this.loadRateForm.stanbyPower = this.loadRateForm.stanbyPower || '1'
        if (key === 'IndustrialFrequency') {
          this.selectedDevice = this.memo[1][this.device.id].IndustrialFrequency.device || +this.device.id
        }
        if (key === 'variableFrequency') {
          this.selectedDevices = this.memo[1][this.device.id].variableFrequency.devices || +this.device.id
        }
      } else {
        this.selectedDevice = +this.device.id
        this.selectedDevices = +this.device.id
      }
      this.avgPower = this.electricityMeterAccumulation = this.maxPower = this.minPower = this.loadingRate = this.capacityRate = this.dataCount = this.loadCount = this.unloadCount = 0
    },
    async saveLoadRateSettings(field, messageField) {
      this.loadRateForm[field] = this.loadRateForm[field].trim()
      if (!this.loadRateForm[field]) {
        return this.$message.warn(this.$t(`device.${messageField}`))
      }
      this[`is${field}Saving`] = true
      let loadRateInfo = this.memo[1][this.device.id]
      if (!loadRateInfo) {
        this.memo[1][this.device.id] = {
          IndustrialFrequency: {},
          variableFrequency: {}
        }
      }
      this.memo[1][this.device.id][this.loadRateType[0]][field] = this.loadRateForm[field]
      try {
        const { message } = await u(this.memo)
        this.$message.success(message)
      } catch(e) {
        console.log(e)
      } finally {
        this[`is${field}Saving`] = false
      }
    },
    async setDeviceTypeAndStatusMap() {
      try {
        const lang = this.lang === 'en' ? 'en-US' : 'zh-CN'
        const dic = await getDict(lang, 'deviceType')
        const res = await getDict(lang, 'deviceStatus')
        this.deviceStatus = res.data.content
        res.data.content.forEach(c => {
          this.runningStatus[c.value].label = c.text
        })
        dic.data.content.forEach(d => {
          deviceTypeMap[d.value] = d.text
        })
      } catch(e) {
        console.log(e)
      }
    },
    async setMenu() {
      try {
        const { data } = await getDeviceGroup(this.$route.query.id)
        this.isFlowmeterShow = !data.elecVisible
        this.deviceList = data.devices
        let device
        for (let i = 0; i < data.devices.length; i++) {
          device = data.devices[i]
          if ((device.type === "LLJ" && this.isFlowmeterShow) || device.type !== "LLJ") {
            const menu = this.sideMenus.find(s => s.key === device.type)
            if (menu) {
              menu.children.push(device)
            } else {
              this.sideMenus.push({
                key: device.type,
                value: deviceTypeMap[device.type],
                children: [device]
              })
              this.defaultOpenKeys.push(device.type)
            }
            if (device.type === "LLJ" || device.type === "DB") {
              this.FOE.push(device)
            }
          }
        }
        this.stationName = data.name
        this.stationId = data.id
        this.stationCode = data.code
        this.defaultSelectedKeys = [this.sideMenus[0].children[0].code]
      } catch(e) {
        console.log(e)
      }
    },
    computedColor(device) {
      let s = device.status || ''
      s = s.split(',')
      s = s.sort((a, b) => {
        const c = this.deviceStatus.find(d => d.value === a)
        const d = this.deviceStatus.find(d => d.value === b)
        return c.priority - d.priority
      })
      return ((this.runningStatus[s[0]] && this.runningStatus[s[0]].color) || '')
    },
    handleUnitChange (value) {
      switch (value) {
        case 's':
        this.options = [1, 5, 30]
          if (this.num) {
            this.num = 30
          }
          this.perSeconds = 1
          break
        case 'm':
          this.options = [1, 5, 30]
          this.perSeconds = 60
          break
        case 'h': 
          this.options = [1, 2, 3, 24]
          if (this.num) {
            this.num = 1
          }
          this.perSeconds = 3600
      }
    },
    showRateMask() {
      const r = JSON.parse(localStorage.getItem('statisticsTime'))
      if (r) {
        const t = localStorage.getItem('saveTime')
        if (t === moment(+new Date()).format('YYYY-MM-DD')) {
          this.rateDateRange = r.map(d => new Date(d))
        } else {
          localStorage.removeItem('saveTime')
          localStorage.removeItem('statisticsTime')
          this.rateDateRange = [new Date(+new Date() - 24 * 3600000), new Date()]
        }
      } else {
        this.rateDateRange = [new Date(+new Date() - 24 * 3600000), new Date()]
      }
      this.rateTarget = this.rateResult = this.rate = ''
      this.rateShow = true
      if (this.device.intervalTime) {
        this.rateInterval = this.device.intervalTime
      }
    },
    async getPoints(d) {
      try {
        const { data } = await getProtocol(d.protocolCode)
        data.points.filter(d => d.dataWrite !== 2).forEach(p => {
          p.zh = p.name
          p.en = p.details?.find(d => d.locale === 'en-US')?.name
          if (!p.en) {
            p.en = p.zh
          }
          if (p.read !== false) {
            p.checked = !!this.selectedPoints.find(s => s === p.code)
            this.points.push(p)
          }
        })
      } catch(e) {
        console.log(e)
      } finally {
        this.isContentShow = true
      }
    },
    async drawSummaryChart() {
      const yAxis = [], series = []
      let point, width = 0, leftOffset = 0, rightOffset = 0, offset, position, length = this.selectedPoints.length
      let y, k
      for (let i = 0; i < length; i++) {
        point = this.selectedPoints[i]
        if (i > 1 && this.pointsDataLengthMap[this.selectedPoints[i - 2].code] > 6) {
          width = 80
        } else if (i > 1 && this.pointsDataLengthMap[this.selectedPoints[i - 2].code] > 4) {
          width = 50
        } else if (i > 1 && this.pointsDataLengthMap[this.selectedPoints[i - 2].code] > 1) {
          width = 38
        } else if (i > 1) {
          width = 30
        }
        if (i % 2 === 0) {
          position = 'left'
          leftOffset += width
          offset = leftOffset
        } else {
          position = 'right'
          rightOffset += width
          offset = rightOffset
        }
        y = {
          type: 'value',
          axisLine: {
            show: true
          },
          axisLabel: {
            show: true,
            fontSize: 12
          },
          splitLine: {
            show: false
          },
          position,
          offset,
          scale: true
        }
        k = this.axisMap[point.code]
        if (k && (k.min || k.min === 0) && k.max) {
          y.min = k.min
          y.max = k.max
        }
        yAxis.push(y)
        series.push({
          type: 'line',
          name: point[this.lang],
          data: this.historyMap[point.code],
          symbol: 'none',
          yAxisIndex: i,
          lineStyle: {
            width: 2
          }
        })
      }
      if (this.isExtrachecked) {
        await this.setFlowData()
        if (this.gkll?.gkll?.data.length) {
          const sp = [...this.selectedPoints].concat([
            { 
              code: 'gkwd',
              name: '工况温度' 
            }, 
            { 
              code: 'gkyl',
              name: '工况压力' 
            }, 
            { 
              code: 'gkll' ,
              name: '工况流量'
            }
          ])
          for (let i = length; i < sp.length; i++) {
            point = sp[i]
            if (i > 1 && this.pointsDataLengthMap[sp[i - 2].code] > 6) {
            width = 80
            } else if (i > 1 && this.pointsDataLengthMap[sp[i - 2].code] > 4) {
              width = 50
            } else if (i > 1 && this.pointsDataLengthMap[sp[i - 2].code] > 1) {
              width = 40
            } else if (i > 1) {
              width = 30
            }
            if (i % 2 === 0) {
              position = 'left'
              leftOffset += width
              offset = leftOffset
            } else {
              position = 'right'
              rightOffset += width
              offset = rightOffset
            }
            yAxis.push({
              type: 'value',
              axisLine: {
                show: true
              },
              axisLabel: {
                show: true,
                fontSize: 12
              },
              splitLine: {
                show: false
              },
              position,
              offset,
              scale: true
            })
            series.push({
              type: 'line',
              name: point.name,
              data: this.gkll[point.code].data,
              symbol: 'none',
              yAxisIndex: i,
              lineStyle: {
                width: 2
              }
            })
          }
        }
      }
      let zoomStart, zoomEnd, grid, dataZoom
      const height = length > 9 ? 1000 : 240
      let chartsWidth = 1200
      const dom = document.querySelector('.container .charts li')
      if (dom) {
        chartsWidth = dom.clientWidth ? (dom.clientWidth - 100) : 1200
      }
      if (!this.summaryChart) {
        zoomStart = 80
        zoomEnd = 100
      } else {
        zoomStart = this.$echarts.getInstanceByDom(document.getElementById('summary')).getOption().dataZoom[0]?.start
        zoomEnd = this.$echarts.getInstanceByDom(document.getElementById('summary')).getOption().dataZoom[0]?.end
        zoomStart = (zoomStart || zoomStart == 0) ? zoomStart : 80
        zoomEnd = (zoomEnd || zoomEnd == 0) ? zoomEnd : 100
        this.summaryChart.dispose()
      }
      if (this.selectedPoints.length > 9) {
        grid = {
          containLabel: true,
          top: '7%',
          bottom: '80%'
        }
        dataZoom = [
          {
            type: 'inside',
            start: zoomStart,
            end: zoomEnd,
            bottom: '77%'
          },
          {
            start: zoomStart,
            end: zoomEnd,
            bottom: '77%'
          }
        ]
      } else {
        grid = {
          containLabel: true
        }
        dataZoom = [
          {
            type: 'inside',
            start: zoomStart,
            end: zoomEnd
          },
          {
            start: zoomStart,
            end: zoomEnd
          }
        ]
      }
      this.summaryChart = this.$echarts.init(
        document.getElementById('summary'),
        null,
        {
          renderer: 'canvas',
          useDirtyRect: false,
          width: chartsWidth,
          height
        }
      )
      this.totalOption = {
        animation: false,
        tooltip: {
          trigger: 'axis',
          position: function (pt) {
            return [pt[0], '1%']
          },
          renderMode: 'richText',
          backgroundColor: 'rgba(0, 0, 0, .1)',
          textStyle: {
            color: '#fff'
          }
        },
        grid,
        xAxis: {
          type: 'time',
          boundaryGap: false
        },
        yAxis,
        series,
        dataZoom
      };
      const summary = document.getElementById('summary').parentNode
      console.log(summary.offsetTop)
      summary.addEventListener('mouseover', e => {
        const canvas = summary.querySelector('canvas')
        if (canvas) {
          canvas.style.zIndex = 1000
        }
      })
      summary.addEventListener('mousemove', e => {
        if (e.offsetY > 268) {
          const canvas = summary.querySelector('canvas')
          if (canvas) {
            canvas.style.zIndex = 0
          }
        }
      })
      summary.addEventListener('mouseleave', () => {
        const canvas = summary.querySelector('canvas')
        if (canvas) {
          canvas.style.zIndex = 0
        }
      });
      (!this.isExtrachecked || this.gkll?.gkll?.data.length) && this.summaryChart.setOption(series.length ? this.totalOption : {}, { replaceMerge: ['xAxis', 'yAxis', 'series'] })
      window.addEventListener('resize', this.summaryChart.resize)
    },
    async getData(d, targetField = 'historyMap', dateField = 'outerDateValue', pointsField = 'points') {
      try {
        const params = {
          deviceId: d.id,
          pointCode: this[pointsField].map(p => p.code) + '',
          startTime: +this[dateField][0],
          endTime: +this[dateField][1] + 24 * 3600000 - 1
        }
        const { data } = await getDeviceHistoryData(params)
        this[targetField] = {}
        let target, time, plm
        this.pointsDataLengthMap = {}
        for (let i = 0; i < data.length; i++) {
          time = parseInt(new Date(data[i].time) / 1000) * 1000
          for (let k in data[i]) {
            target = this[targetField]
            plm = this.pointsDataLengthMap
            if (target[k]) {
              target[k].push([time, data[i][k]])
              plm[k] = (plm[k] + '').length > (data[i][k] + '').length ? (plm[k] + '').length : (data[i][k] + '').length
            } else {
              target[k] = [[time, data[i][k]]]
              plm[k] = (plm[k] + '').length
            }
          }
        }
      } catch(e) {
        console.log(e)
      }
    },
    drawPointsCharts() {
      let option, point
      let zoomStart, zoomEnd
      let width = 1200
      const dom = document.querySelector('.container .charts li')
      if (dom) {
        width = dom.clientWidth ? (dom.clientWidth - 100) : 1200
      }
      for (let i = 0; i < this.points.length; i++) {
        point = this.points[i]
        if (!this[`charts${i}`]) {
          zoomStart = 80
          zoomEnd = 100
          this[`charts${i}`] = this.$echarts.init(
            document.getElementById(point.name),
            null,
            {
              renderer: 'canvas',
              useDirtyRect: false,
              width,
              height: 240
            }
          )
        } else {
          zoomStart = this.$echarts.getInstanceByDom(document.getElementById(point.name)).getOption().dataZoom[0]?.start
          zoomEnd = this.$echarts.getInstanceByDom(document.getElementById(point.name)).getOption().dataZoom[0]?.end
          zoomStart = (zoomStart || zoomStart == 0) ? zoomStart : 80
          zoomEnd = (zoomEnd || zoomEnd == 0) ? zoomEnd : 100
        }
        option = {
          animation: false,
          tooltip: {
            trigger: 'axis',
            position: function (pt) {
              return [pt[0], '10%']
            },
            backgroundColor: 'rgba(0, 0, 0, .1)',
            textStyle: {
              color: '#fff'
            },
            renderMode: 'richText',
            backgroundColor: 'rgba(0, 0, 0, .1)',
            textStyle: {
              color: '#fff'
            }
          },
          xAxis: {
            type: 'time',
            boundaryGap: false
          },
          yAxis: {
            type: 'value',
            boundaryGap: [0, '100%']
          },
          dataZoom: [
            {
              type: 'inside',
              start: zoomStart,
              end: zoomEnd
            },
            {
              start: zoomStart,
              end: zoomEnd
            }
          ],
          series: [
            {
              name: point[this.lang],
              type: 'line',
              smooth: true,
              symbol: 'none',
              areaStyle: {},
              data: this.historyMap[point.code],
              markPoint: {
                data: [
                  {
                    type: 'max',
                    name: '最大值'
                  },
                  {
                    type: 'min',
                    name: '最小值'
                  }
                ]
              }
            }
          ]
        }
        this[`charts${i}`].setOption(option, { replaceMerge: ['xAxis', 'yAxis', 'series'] })
        window.addEventListener('resize', this[`charts${i}`].resize)
      }
    },
    async render(d = this.device) {
      this.gkll = undefined
      if (this.webSocket) {
        this.webSocket.close()
        this.webSocket = null
        clearTimeout(this.timeout1)
        this.timeout1 = null
        clearTimeout(this.timeout2)
        this.timeout2 = null
        this.connecting = false
      }
      if (d.id !== this.device?.id) {
        this.device = d
        this.deviceName = d.name
        this.deviceType = d.type
        this.customerId = d.customerId
        // this.rateInterval = d.intervalTime
        if (!d.intervalTime) {
          const { data } = await searchDeviceList(1, 10, {
            query: [],
            filter: [
              {
                field: 'id',
                value: d.id
              }
            ],
            sort: []
          })
          if (data.total) {
            d.intervalTime = data.records[0].intervalTime
          } else {
            d.intervalTime = 180
          }
        }
        this.rateInterval = d.intervalTime
        const LKEY = `${this.$route.query.stationCode} ${d.code}`
        const LVALUE = JSON.parse(localStorage.getItem(LKEY))
        this.selectedPoints = LVALUE || []
        if (this.summaryChart) {
          window.removeEventListener('resize', this.summaryChart.resize)
          this.summaryChart.dispose()
          this.summaryChart = null
        }
        for (let i = 0; i < this.points.length; i++) {
          if (this[`charts${i}`]) {
            window.removeEventListener('resize', this[`charts${i}`].resize)
            this[`charts${i}`].dispose()
            this[`charts${i}`] = null
          }
        }
        this.points = []
        await this.getPoints(d)
        this.setRate(false)
      }
      const reduce = parseInt((this.outerDateValue[1] - this.outerDateValue[0]) / 1000 / 3600 / 24)
      if (reduce > 31) {
        return this.$message.warn(this.lang === 'en' ? 'Date range up to one month' : '日期范围最多一个月')
      }
      this.isChartsShow = false
      this.selectedPoints = this.points.filter(p => p.checked)
      await this.getData(d)
      if (this.buttonsShow['query:gk:flow']) {
        const K = `${this.$route.query.stationCode} ${this.device.code}F`
        const f = JSON.parse(localStorage.getItem(K))
        if (f) {
          this.flowForm = f
          this.selectDeviceForFlow({id: f.id, protocolCode: f.protocolCode})
          this.selectPDeviceForFlow({id: f.pid, protocolCode: f.pProtocolCode})
          const key = `${this.$route.query.stationCode} ${this.device.code}FC`
          const flag = localStorage.getItem(key) === 'true'
          this.isExtrachecked = flag
        } else {
          this.flowForm = {
            id: '',
            protocolCode: '',
            pProtocolCode: '',
            pointCode: '',
            pPointCode: '',
            tMock: false,
            pid: '',
            pMock: false,
            tValue: '',
            pValue: '',
            pPointName: '工况压力',
            pointName: '工况温度'
          }
          this.isExtrachecked = false
        }
      } else {
        this.isExtrachecked = false
      }
      
      this.$nextTick(() => {
        this.handleExtraChange({ target: { checked: this.isExtrachecked } })
        this.drawPointsCharts()
      })
      this.isChartsShow = true
    },
    async exportExcel() {
      const reduce = parseInt((this.outerDateValue[1] - this.outerDateValue[0]) / 1000 / 3600 / 24)
      if (reduce > 31) {
        return this.$message.warn(this.lang === 'en' ? 'Date range up to one month' : '日期范围最多一个月')
      }
      if (!this.exportType && this.device.type === 'LLJ' && !this.gkll) {
        const f = await this.setFlowData()
        if (!f) {
          this.extraFlowShow = true
        }
        console.log(this.gkll);
      }
      const dataUnitsGap = this.perSeconds * this.num * 1000
      const headerList = [this.$t('common.deviceCode'), this.$t('common.deviceName'), this.$t('common.model'), this.$t('common.brand'), this.$t('common.customer')]
      const history = []
      let h
      let point
      for (let i = 0; i < this.points.length; i++) {
        point = this.points[i]
        if (this.exportType) {
          if (this.points[i].checked) {
            headerList.push(point[this.lang] + '(' + point.unit + ')')
          }
        } else {
          headerList.push(point[this.lang] + '(' + point.unit + ')')
        }
      }
      if (this.device.type === 'LLJ' && (this.exportType && this.isExtrachecked || !this.exportType)) {
        headerList.push(this.$t('device.workingTemperature'))
        headerList.push(this.$t('device.workingPressure'))
        headerList.push(this.$t('device.workingFlow'))
      }
      headerList.push(this.$t('device.acquisitionDate'))
      const excelList = [headerList]
      this.originHistoryData = []
      let resultModel = {}, targetIndex = 1
      for (let i = 0; i < (this.historyMap?.time?.length || 0); i++) {
        resultModel = {}
        for (let k in this.historyMap) {
          if (k === 'time') {
            targetIndex = 0
          } else {
            targetIndex = 1
          }
          resultModel[k] = this.historyMap[k][i][targetIndex]
        }
        this.originHistoryData.push(resultModel)
      }
      if (this.originHistoryData?.length) {
        history[0] = this.originHistoryData[0]
        if (this.device.type === 'LLJ' && (this.exportType && this.isExtrachecked || !this.exportType)) {
          history[0].gkwd = this.gkll?.gkwd.data?.[0][1] || '-'
          history[0].gkyl = this.gkll?.gkyl.data?.[0][1] || '-'
          history[0].gkll = this.gkll?.gkll.data?.[0][1] || '-'
        }
        let start = (this.originHistoryData[0].time + dataUnitsGap), end = (this.originHistoryData[this.originHistoryData.length - 1].time + dataUnitsGap), left = 0
        for (let i = start; i < end; i += dataUnitsGap) {
          for (let j = left; j < this.originHistoryData.length; j++) {
            h = this.originHistoryData[j]
            if (h.time > i) {
              if (j - left <= 1) {
                break
              }
              left = j - 1
              h = this.originHistoryData[left]
              if (this.device.type === 'LLJ' && (this.exportType && this.isExtrachecked || !this.exportType)) {
                h.gkwd = this.gkll.gkwd.data?.[left][1] || '-'
                h.gkyl = this.gkll.gkyl.data?.[left][1] || '-'
                h.gkll = this.gkll.gkll.data?.[left][1] || '-'
              }
              history.push(h);
              break
            }
            if (h.time === i) {
              left = j
              if (this.device.type === 'LLJ' && (this.exportType && this.isExtrachecked || !this.exportType)) {
                h.gkwd = this.gkll.gkwd.data?.[j][1] || '-'
                h.gkyl = this.gkll.gkyl.data?.[j][1] || '-'
                h.gkll = this.gkll.gkll.data?.[j][1] || '-'
              }
              history.push(h);
              break
            }
          }
        }
      }
      let data
      for (let k in history) {
        data = []
        data.push(this.device.code)
        data.push(this.device.name)
        data.push(this.device.model)
        data.push(this.device.brand)
        data.push(this.device.company)
        for (let j = 0; j < this.points.length; j++) {
          if (this.exportType) {
            if (this.points[j].checked) {
              data.push(+history[k][this.points[j].code])
            }
          } else {
            data.push(+history[k][this.points[j].code])
          }
        }
        if (this.device.type === 'LLJ' && (this.exportType && this.isExtrachecked || !this.exportType)) {
          // if (this.selectedPoints.find(s => s.name === '工况温度')) {
          //   data.push(this.totalOption.series.at(-3).data[i][1] + '\t,')
          //   data.push(this.totalOption.series.at(-2).data[i][1] + '\t,')
          //   data.push(this.totalOption.series.at(-1).data[i][1] + '\t,')
          // } else {
          //   data.push('\t,')
          //   data.push('\t,')
          //   data.push('\t,')
          // }
          data.push(history[k].gkwd + '\t')
          data.push(history[k].gkyl + '\t')
          data.push(history[k].gkll + '\t')
        }
        data.push(formatDate(history[k].time, 1))
        excelList.push(data)
      }
      const wb = XLSX.utils.book_new()
      // 创建一个工作表
      const ws = XLSX.utils.aoa_to_sheet(excelList)

      // 遍历工作表中的所有单元格
      for (const cellAddress in ws) {
          if (cellAddress[0] === '!') continue // 忽略特殊单元格
          const cell = ws[cellAddress]

          // 检查单元格的值是否是可以转换为数字的字符串
          if (cell.v && !isNaN(cell.v) && +cell.v != Infinity) {
            cell.t = 'n' // 将单元格类型设置为数字
            cell.v = parseFloat(cell.v);// 确保单元格的值为数字
          }
      }

      // 将工作表添加到工作簿中
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1")

      // 导出 Excel 文件
      XLSX.writeFile(wb, this.stationName + ' ' + this.device.name + this.$t('device.history') + formatDate(this.outerDateValue[0]) + ' - ' + formatDate(this.outerDateValue[1]) + '.xlsx')
    },
    openDeviceCompareModal() {
      this.deviceCompareVisible = true
      this.innerDate = [...this.outerDateValue]
      if (this.device.id) {
        this.deviceToCompare = this.device.code
        this.setActiveInnerDevice(this.device)
      }
    },
    closeDeviceCompareModal() {
      this.deviceCompareVisible = false
      this.innerDeviceCode = ''
      this.deviceComparationPoints = []
      this.deviceComparationParamsList = {}
      if (this.deviceComparationChart) {
        this.deviceComparationChart.dispose()
        this.deviceComparationChart = null
      }
      this.deviceToCompare = ''
    },
    clearDevcieComperationChart() {
      for (let key in this.deviceComparationParamsList) {
        this.deviceComparationParamsList[key].data = {}
        this.deviceComparationParamsList[key].points.forEach(p => p.checked = false)
        this.deviceComparationParamsList[key].length = 0
      }
      if (this.deviceComparationChart) {
        this.deviceComparationChart.dispose()
        this.deviceComparationChart = null
      }
      this.$forceUpdate()
    },
    onInnerDateChange(dateArray) {
      const startTime = +dateArray[0]
      const endTime = +dateArray[1] + 24 * 3600000 - 1
      const reduce = parseInt((endTime - startTime) / 1000 / 60 / 60 / 24)
      if (reduce > 31) {
        return this.$message.warn('日期范围最多一个月')
      }
      this.setDeviceComparationData()
    },
    async setActiveInnerDevice(item) {
      this.comparationDeviceCode = item.id
      this.deviceCompareLoading = true
      if (this.deviceComparationParamsList[item.id]) {
        this.deviceComparationPoints = this.deviceComparationParamsList[item.id].points
        this.deviceCompareLoading = false
        return
      }
      try {
        const { data } = await getProtocol(item.protocolCode)
        this.deviceComparationParamsList[item.id] = {
          points: data.points.filter(d => d.dataWrite !== 2).map(p => {
            (p.details || []).forEach(d => {
              p[d.locale.split('-')[0]] = d.name
            })
            if (!p.zh) {
              p.zh = p.name
            }
            if (!p.en) {
              p.en = p.zh
            }
            return p
          }),
          data: {}
        }
        this.deviceComparationPoints = this.deviceComparationParamsList[item.id].points
      } catch(e) {
        console.log(e)
      } finally {
        this.deviceCompareLoading = false
      }
    },
    async setDeviceComparationData() {
      const promises = []
      const startTime = +this.innerDate[0], endTime = +this.innerDate[1] + 24 * 3600000 - 1
      for (let id in this.deviceComparationParamsList) {
        const points = Object.keys(this.deviceComparationParamsList[id].data).map(d => {
          this.deviceComparationParamsList[id].data[d] = []
          return d
        })
        if (points.length) {
          const params = {
            deviceId: id,
            pointCode: points + '',
            startTime,
            endTime
          }
          promises.push(
            new Promise(async (resolve, reject) => {
              try {
                const { data } = await getDeviceHistoryData(params)
                for (let i = 0; i < data.length; i++) {
                  for (let j = 0; j < points.length; j++) {
                    this.deviceComparationParamsList[id].data[points[j]].push([
                      +new Date(data[i].time),
                      data[i][points[j]]
                    ])
                    if (!this.deviceComparationParamsList[id].length) {
                      this.deviceComparationParamsList[id].length = {
                        [points[j]]: 0
                      }
                    }
                    this.deviceComparationParamsList[id].length[points[j]] = Math.max(this.deviceComparationParamsList[id].length[points[j]], (data[i][points[j]] + '').length)
                  }
                }
                resolve()
              } catch(e) {
                console.log(e)
                reject(e)
              }
            })
          )
        }
      }
      Promise.all(promises).then(this.drawDeviceComparationChart)
    },
    async handleInnerChange(e, innerDeviceCode, item) {
      item.checked = e.target.checked
      if (item.checked) {
        this.deviceComparationParamsList[innerDeviceCode].data[item.code] = []
      } else {
        delete this.deviceComparationParamsList[innerDeviceCode].data[item.code]
      }
      // this.deviceCompareLoading = true
      // try {
      //   this.setDeviceComparationData()
      // } catch(e) {
      //   console.log(e)
      // } finally {
      //   this.deviceCompareLoading = false
      // }
    },
    drawDeviceComparationChart() {
      const yAxis = {
        type: 'value',
        axisLine: {
          show: true
        },
        axisLabel: {
          show: true,
          fontSize: 12
        },
        splitLine: {
          show: false
        },
        position,
        offset,
        scale: true
      }
      if (this.yAxis.min && !isNaN(+this.yAxis.min)) {
        yAxis.min = +this.yAxis.min
      }
      if (this.yAxis.max && !isNaN(+this.yAxis.max)) {
        yAxis.max = +this.yAxis.max
      }
      const  series = [], pointsOfChart = []
      let point, width = 0, leftOffset = 0, rightOffset = 0, offset, position, length, pointDataLength, cPoint, name
      for (let deviceId in this.deviceComparationParamsList) {
        for (let pointCode in this.deviceComparationParamsList[deviceId].data) {
          pointsOfChart.push({
            deviceId,
            pointCode
          })
        }
      }
      length = pointsOfChart.length
      for (let i = 0; i < length; i++) {
        point = pointsOfChart[i]
        const device = this.deviceList.find(d => d.id == point.deviceId)
        name = device?.code + ' - ' + device?.name + ' - ' + this.deviceComparationParamsList[point.deviceId].points.find(p => p.code === point.pointCode)?.[this.lang]
        if (i > 1) {
          cPoint = pointsOfChart[i - 2]
          pointDataLength = this.deviceComparationParamsList[cPoint.deviceId]?.length?.[cPoint.pointCode] || 0
          if (pointDataLength > 6) {
            width = 80
          } else if (pointDataLength > 4) {
            width = 50
          } else if (pointDataLength > 1) {
            width = 38
          } else {
            width = 30
          }
        }
        if (i % 2 === 0) {
          position = 'left'
          leftOffset += width
          offset = leftOffset
        } else {
          position = 'right'
          rightOffset += width
          offset = rightOffset
        }
        series.push({
          type: 'line',
          name,
          // data: [[1725292800003, 0], [1725322600000, 0.69], [1725330780008, 0.69]],
          data: this.deviceComparationParamsList[point.deviceId].data[point.pointCode],
          symbol: 'none',
          lineStyle: {
            width: 2
          }
        })
      }
      if (!this.deviceComparationChart) {
        this.deviceComparationChart = this.$echarts.init(
          document.getElementById('deviceComparation'),
          null,
          {
            render: 'canvas',
            useDirtyRect: false,
            height: 560
          }
        )
      }
      const option = {
        tooltip: {
          trigger: 'axis',
          position: function (pt) {
            return [pt[0], '10%']
          },
          renderMode: 'richText',
          backgroundColor: 'rgba(0, 0, 0, .1)',
          textStyle: {
            color: '#fff'
          }
        },
        grid: {
          containLabel: true
        },
        xAxis: {
          type: 'time',
          boundaryGap: false
        },
        yAxis,
        series,
        dataZoom: [
          {
            type: 'inside',
            start: 80,
            end: 100
          },
          {
            start: 80,
            end: 100
          }
        ]
      }
      this.deviceComparationChart.setOption(series.length ? option : {}, { replaceMerge: ['xAxis', 'yAxis', 'series'] })
    },
    initialAvgConsumptionChart () {
      this.avgConsumptionVisible = true
      this.optionOfAvgConsumptionChart = {
        tooltip: {
          trigger: 'axis',
          renderMode: 'richText',
          backgroundColor: 'rgba(0, 0, 0, .1)',
          textStyle: {
            color: '#fff'
          }
        },
        grid: {
          top: 70,
          bottom: 50
        },
        xAxis: [],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: []
      }
      this.$nextTick(() => {
        this.avgConsumptionChart = this.$echarts.init(
        document.querySelector('.chart'),
        null,
        {
          render: 'canvas',
          useDirtyRect: false
        }
      )
        // this.avgConsumptionChart.setOption(this.optionOfAvgConsumptionChart)
      })
    },
    closeAvgConsumptionMask () {
      this.avgConsumptionVisible = false
      this.avgConsumptionChart.clear()
      this.ranges = []
    },
    addRange () {
      this.ranges.push({
        id: nanoid(),
        date: '',
        startTime: '',
        endTime: '',
        deviceCode: [],
        checked: false
      })
    },
    removeRange () {
      this.ranges.splice(this.ranges.length - 1, 1)
      if (this.ranges.length === 0) {
        this.avgConsumptionChart.clear()
      }
    },
    async renderChart () {
      console.log('renderChart');
      const series = [],
        xAxis = [],
        rangesRecord = []
      let flag = false,
        max = 0,
        unlimit = true
      for (let i = 0; i < this.ranges.length; i++) {
        if (this.ranges[i].checked) {
          const { date, startTime, endTime } = this.ranges[i]
          if (!date || !startTime || !endTime) {
            this.$message.warning('请完善相关时间信息')
            flag = true
            break
          }
          let start = +startTime.split(':')[0]
          let end = +endTime.split(':')[0]
          if (start[0] > end) {
            this.$message.warning('请选择正确的时间范围')
            flag = true
            break
          }
          let gap = end - start + 1
          max = Math.max(max, gap)
          const range = {
            ...this.ranges[i],
            date: moment(+new Date(this.ranges[i].date)).format('YYYY-MM-DD'),
            start,
            end,
            gap,
            index: i + 1,
            show: false
          }
          if (unlimit) {
            if (gap === max) {
              range.show = true
              unlimit = false
            }
          }
          rangesRecord.push(range)
        }
      }
      if (flag) {
        return
      }
      for (let i = 0; i < rangesRecord.length; i++) {
        const record = rangesRecord[i]
        const { start, end, date, index, show, deviceCode } = record
        const { data } = await getDayReport(
          date,
          deviceCode + ''
        )
        const xAxisData = []
        const seriesData = []
        const endsIndex = data.length - 2
        for (let j = start - 1; j < start + max - 1; j++) {
          if (end < endsIndex) {
            if (j <= end) {
              xAxisData.push(data[j].datetime)
              seriesData.push(data[j].avgConsumption)
            } else {
              let time = data[j]?.datetime || `${date} ${j < 9 ? '0' + (j + 1) : j + 1}:00`
              xAxisData.push(time)
            }
          } else {
            if (j <= endsIndex) {
              xAxisData.push(data[j].datetime)
              seriesData.push(data[j].avgConsumption)
            } else if (j < end) {
              xAxisData.push(`${date} ${j < 9 ? '0' + (j + 1) : j + 1}:00`)
              seriesData.push(undefined)
            } else {
              xAxisData.push(`${date} ${j < 9 ? '0' + (j + 1) : j + 1}:00`)
            }
          }
        }
        xAxis.push({
          show,
          type: 'category',
          position: 'bottom',
          axisTick: {
            alignWithLabel: true
          },
          axisLine: {
            onZero: true
          },
          data: xAxisData
        })
        series.push({
          name: `${this.$t('device.range')}${index}`,
          type: 'line',
          smmoth: true,
          symbol: 'none',
          xAxisIndex: i,
          axisTick: {
            alignWithLabel: true
          },
          axisLine: {
            onZero: false
          },
          data: seriesData
        })
      }
      this.optionOfAvgConsumptionChart.xAxis = xAxis
      this.optionOfAvgConsumptionChart.series = series
      this.avgConsumptionChart.setOption(series.length ? this.optionOfAvgConsumptionChart : {}, { replaceMerge: ['xAxis', 'yAxis', 'series'] })
    },
    initialDeviceTChart () {
      this.timeShow = true
      this.optionOfTimeC = {
        tooltip: {
          trigger: 'axis',
          position(pt) {
            return [pt[0], '10%']
          },
          renderMode: 'richText',
          backgroundColor: 'rgba(0, 0, 0, .1)',
          textStyle: {
            color: '#fff'
          }
        },
        grid: {
          top: 70,
          bottom: 150,
          containLabel: true
        },
        xAxis: {
          type: 'time',
          boundaryGap: true
        },
        yAxis: {
          type: 'value'
        },
        dataZoom: [
          {
            type: 'inside',
            start: 0,
            end: 20
          },
          {
            start: 0,
            end: 20
          }
        ],
        series: []
      }
      this.$nextTick(() => {
        this.time = this.$echarts.init(
          document.getElementById('time'),
          null,
          {
            render: 'canvas',
            useDirtyRect: false
          }
        )
        this.time.setOption(this.optionOfTimeC)
      })
    },
    closTime () {
      this.timeShow = false
      this.timeRanges = []
      this.timeDevice = ''
      this.time.clear()
    },
    addTimeRange () {
      this.timeRanges.push({
        id: nanoid(),
        dateRange: [],
        startTime: this.nowDateStart,
        endTime: this.nowDateEnd
      })
    },
    async timeAnalyse () {
      this.tLoading = true
      const series = []
      const xAxis = []
      try {
        for (let i = 0; i < this.timeRanges.length; i++) {
          const { startTime, endTime } = this.timeRanges[i]
          let { data } = await getDeviceHistoryData({
            deviceId: this.device.id,
            pointCode: this.timeDevice,
            startTime,
            endTime
          })
          data = data.map(item => [+new Date(item.time), item[this.timeDevice]])
          series.push({
            name: `${this.$t('device.range')}${i + 1}`,
            type: 'line',
            smooth: true,
            xAxisIndex: i,
            symbol: 'none',
            emphasis: {
              focus: 'series'
            },
            data
          })
          xAxis.push({
            type: 'time',
            show: false
          })
        }
        xAxis[0].show = true
        this.optionOfTimeC.series = series
        this.optionOfTimeC.xAxis = xAxis
        this.time.setOption(this.optionOfTimeC, { replaceMerge: ['series', 'xAxis'] })
      } finally {
        this.tLoading = false
      }
    },
    timeGoBack () {
      this.timeRanges.pop()
    },
    changeTime (e, i) {
      this.timeRanges[i].startTime = +new Date(e[0].toLocaleString().split(' ')[0])
      this.timeRanges[i].endTime = +new Date(e[1].toLocaleString().split(' ')[0]) + 24 * 3600 * 1000 - 1
    },
    async showRemoveHistroyDataConfirm() {
      this.removeTimeRange = [
        moment(this.startDate),
        moment(this.endDate)
      ]
      this.isRemoveHistroyDataConfirm = true
    },
    async removeHistroyData() {
      const temp = {
        deviceId: this.device.id,
        startTime: +new Date(this.removeTimeRange[0]),
        endTime: +new Date(this.removeTimeRange[1])
      }

      try {
        const r = await deleteDeviceHistoryData(temp)
        this.$message.success(r.message)
        this.render(this.device)
        this.isRemoveHistroyDataConfirm = false
      } catch(e) {
        this.$message.error(e.message || this.$t('messages.ftd'))
      }
    },
    handlePointCheckedChange(e, item) {
      item.checked = e.target.checked
      this.selectedPoints = this.points.filter(p => p.checked)
      const LKEY = `${this.$route.query.stationCode} ${this.device.code}`
      const LVALUE = this.selectedPoints.map(p => p.code)
      localStorage.setItem(LKEY, JSON.stringify(LVALUE))
      this.drawSummaryChart()
    },
    openRangeMask (item, index) {
      this.index = index
      this.dataPointName = item.name
      this.shrink = false
      this.$refs.range.style.scale = 'unset'
      this.rangeShow = true
    },
    closeRangeMask () {
      this.rangeShow = false
      this.rangesChart?.clear()
      this.dataRanges = []
      this.dataRangeDetail = {}
    },
    handleMouseDown (e) {
      const { range } = this.$refs
      const x = e.pageX - range.offsetLeft
      const y = e.pageY - range.offsetTop
      document.addEventListener('mousemove', move)
      function move(e) {
        range.style.left = e.pageX - x + 'px'
        range.style.top = e.pageY - y + 'px'
      }
      function remove() {
        document.removeEventListener('mousemove', move)
      }
      document.addEventListener('mouseup', remove)
    },
    setShrink () {
      this.shrink = !this.shrink
      if (this.shrink) {
        this.$refs.range.style.scale = '.7'
      } else {
        this.$refs.range.style.scale = 'unset'
      }
    },
    addDataRange () {
      this.dataRanges.push({
        id: nanoid(),
        min: '',
        max: ''
      })
    },
    goBack () {
      const r = this.dataRanges.at(-1)
      if (r.min || r.max) {
        r.min = r.max = ''
      } else {
        this.dataRanges.pop()
      }
    },
    renderRangesChart () {
      const xAxisData = [],
        seriesData = []
      for (let key in this.dataRangeDetail) {
        xAxisData.push(key)
        seriesData.push(this.dataRangeDetail[key])
      }
      if (!this.rangesChart) {
        this.rangesChart = this.$echarts.init(
          document.querySelector('#ranges'),
          null,
          {
            render: 'canvas',
            useDirtyRect: false
          }
        )
      }
      const option = {
        tooltip: {
          trigger: 'axis',
          renderMode: 'richText',
          backgroundColor: 'rgba(0, 0, 0, .1)',
          textStyle: {
            color: '#fff'
          }
        },
        xAxis: {
          type: 'category',
          data: xAxisData
        },
        yAxis: {
          type: 'value',
          splitLine: {
            lineStyle: {
              color: '#ccc'
            }
          }
        },
        series: [
          {
            data: seriesData,
            type: 'bar',
            itemStyle: {
              color: "#37A2FF"
            },
            label: {
              show: true,
              fontSize: 16,
              position: 'top',
              color: '#fff',
              formatter: (val) => {
                return ((val.data / this.totalDataLength) * 100).toFixed(2) + '%'
              }
            }
          }
        ]
      }
      this.rangesChart.setOption(option, { replaceMerge: ['xAxis', 'series'] })
    },
    onRangeDateChange (dateArray) {
      const startDate = new Date(dateArray[0]).getTime()
      const endDate = new Date(dateArray[1]).getTime() + 24 * 60 * 60 * 1000 - 1
      const reduce = parseInt((endDate - startDate) / 1000 / 60 / 60 / 24)
      if (reduce > 31) {
        return message.warn('日期范围最多一个月')
      }
      this.rangeStartDate = startDate
      this.rangeEndDate = endDate
    },
    closRate() {
      this.rateShow = false
    },
    async analyse () {
      this.isLoading = true
      const index = this.index
      const { rangeStartDate: startTime, rangeEndDate: endTime } = this
      let data
      try {
        const historyList = await getDeviceHistoryData({
          deviceId: this.device.id,
          pointCode: this.points[index].code,
          startTime,
          endTime
        })
        data = historyList.data
        this.dataRangeDetail = {}
        this.totalDataLength = data.length
        for (let i = 0; i < this.dataRanges.length; i++) {
          const { min, max } = this.dataRanges[i]
          let key = `${min} - ${max}`
          this.dataRangeDetail[key] = 0
          for (let j = 0; j < data.length; j++) {
            const r = data[j][this.points[index].code]
            if (r >= +min && r < +max) {
              this.dataRangeDetail[key]++
            }
          }
        }
        this.$forceUpdate()
      } finally {
        this.isLoading = false
      }
    },
    saveTime() {
      localStorage.setItem('statisticsTime', JSON.stringify(this.rateDateRange))
      localStorage.setItem('saveTime', moment(+new Date()).format('YYYY-MM-DD'))
    },
    async setRate(f) {
      let startTime, endTime
      if (!this.rateDateRange || this.rateDateRange.length < 2 || !this.rateInterval) {
        if (f) {
          this.rateTarget = this.rateResult = '0'
          this.rate = '0%'
        } else {
          this.defaultRate = '0%'
        }
        return
      }
      if (f) {
        startTime = +this.rateDateRange[0]
        endTime = +this.rateDateRange[1]
        this.isRateLoading = true
      } else {
        const now = +new Date()
        startTime = now - 24 * 3600000
        endTime = now
      }
      try {
        const { data } = await getDeviceHistoryData({
          deviceId: this.device.id,
          pointCode: this.points.map(p => p.code) + '',
          startTime,
          endTime
        })
        if (data.length < 1) {
          const target = Math.floor((+this.rateDateRange[1] - +this.rateDateRange[0]) / (this.rateInterval * 1000))
          if (f) {
            this.rateTarget = target
            this.rateResult = '0'
            this.rate = '0%'
          } else {
            this.defaultRate = '0%'
          }
          return
        }
        let result = 1
        const gap = (this.rateInterval || 180) * 1000
        let start = (Math.floor(+new Date(data[0].time) / 1000) * 1000 + gap), end = (+new Date(data[data.length - 1].time) + gap), left = 0, h
        for (let i = start; i < end; i += gap) {
          for (let j = left; j < data.length; j++) {
            h = data[j]
            h.time = Math.floor(+new Date(h.time) / 1000) * 1000
            if (h.time > i) {
              if (j - left <= 1) {
                break
              }
              left = j - 1
              result++
              break
            }
            if (h.time === i) {
              left = j
              result++
              break
            }
          }
        }
        const target = Math.floor((+this.rateDateRange[1] - +this.rateDateRange[0]) / (this.rateInterval * 1000))
        if (f) {
          this.rateTarget = target
          this.rateResult = result
          this.rate = (result / target * 100).toFixed(2) + '%'
        } else {
          this.defaultRate = (result / target * 100).toFixed(2) + '%'
        }
      } catch(e) {
        console.log(e)
      } finally {
        this.isRateLoading = false
      }
    },
    handleC(e) {
      e.preventDefault()
      const K = `${this.$route.query.stationCode} ${this.device.code}F`
      const f = JSON.parse(localStorage.getItem(K))
      if (f) {
        this.flowForm = f
        this.selectDeviceForFlow({id: f.id, protocolCode: f.protocolCode})
        this.selectPDeviceForFlow({id: f.pid, protocolCode: f.pProtocolCode})
        const key = `${this.$route.query.stationCode} ${this.device.code}FC`
        const flag = localStorage.getItem(key) === 'true'
        this.isExtrachecked = flag
      } else {
        this.clearFlowForm()
      }
      this.extraFlowShow = true
    },
    clearFlowForm() {
      this.flowForm = {
        id: '',
        protocolCode: '',
        pProtocolCode: '',
        pointCode: '',
        pPointCode: '',
        tMock: false,
        pid: '',
        pMock: false,
        tValue: '',
        pValue: '',
        pPointName: '工况压力',
        pointName: '工况温度'
      }
    },
    confirmExtraForm() {
      const LKEY = `${this.$route.query.stationCode} ${this.device.code}F`
      localStorage.setItem(LKEY, JSON.stringify(this.flowForm))
      this.extraFlowShow = false
      this.handleExtraChange({ target: { checked: true } })
      // this.drawSummaryChart()
    },
    async setFlowData() {
      if ((!this.flowForm.tMock && !this.flowForm.pointCode) || (!this.flowForm.pMock && !this.flowForm.pPointCode)) {
        this.isExtrachecked = false
        this.$refs.extra.value = this.$refs.extra.checked = this.isExtrachecked
        this.$message.warn('请配置完整的工况参数')
        return false
      }
      this.isFlowLoading = true
      try {
        const pressureData = []
        const temperatureData = []
        const flows = []
        let less = 0, t, p, flow, time, gap1, gap2, isFlow = true
        if (this.flowForm.tMock) {
          t = isNaN(+this.flowForm.tValue) ? 0 : +this.flowForm.tValue
          for (let i = 0; i < this.historyMap.time.length; i++) {
            time = this.historyMap.time[i][0]
            if (this.historyMap.time[i][1] !== '-') {
              temperatureData.push([
                time,
                t
              ])
              if (!this.pointsDataLengthMap.gkwd) {
                this.pointsDataLengthMap.gkwd = (t + '').length
              }
            } else {
              temperatureData.push([
                time,
                "-"
              ])
            }
          }
        } else {
          const { data } = await getDeviceHistoryData({
            deviceId: this.flowForm.id,
            pointCode: this.flowForm.pointCode,
            startTime: +this.outerDateValue[0],
            endTime: +this.outerDateValue[1] + 24 * 3600000 - 1
          })
          if (data.length) {
            let targetTime, code = this.flowForm.pointCode
            for (let i = 0; i < this.historyMap.time.length; i++) {
              targetTime = this.historyMap.time[i][0]
              if (this.historyMap.time[i][1] !== '-') {
                if (less < data.length - 1) {
                  for (let j = less; j < data.length; j++) {
                    time = +new Date(data[j].time)
                    if (time > targetTime) {
                      less = j
                      if (j > 0) {
                        gap1 = Math.abs(targetTime - data[j - 1].time)
                        gap2 = Math.abs(targetTime - time)
                        temperatureData.push([
                          targetTime,
                          gap1 < gap2 ? data[j - 1][code] : data[j][code]
                        ])
                      } else {
                        temperatureData.push([
                          targetTime,
                          data[less][code]
                        ])
                      }
                      break
                    } else if (time == targetTime) {
                      less = j
                      temperatureData.push([
                        targetTime,
                        data[less][code]
                      ])
                      break
                    }
                  }
                } else {
                  temperatureData.push([
                    this.historyMap.time[i][0],
                    data[less][code]
                  ])
                }
                this.pointsDataLengthMap.gkwd = Math.max(this.pointsDataLengthMap.gkwd || 0, (temperatureData[i][1] + '').length)
              } else {
                temperatureData.push([
                  targetTime,
                  "-"
                ])
              }
            }
          } else {
            for (let i = 0; i < this.historyMap.time.length; i++) {
              temperatureData.push([
                this.historyMap.time[i][0],
                '-'
              ])
            }
            this.pointsDataLengthMap.gkwd = 1
            isFlow = false
          }
        }

        if (this.flowForm.pMock) {
          p = isNaN(+this.flowForm.pValue) ? 0 : +this.flowForm.pValue
          for (let i = 0; i < this.historyMap.time.length; i++) {
            time = this.historyMap.time[i][0]
            if (this.historyMap.time[i][1] !== '-') {
              pressureData.push([
                time,
                p
              ])
              if (!this.pointsDataLengthMap.gkyl) {
                this.pointsDataLengthMap.gkyl = (p + '').length
              }
            } else {
              pressureData.push([
                time,
                "-"
              ])
            }
            if (pressureData[i][1]) {
              if (pressureData[i][1] === '-') {
                flow = '-'
              } else {
                flow = (0.101325 * this.historyMap.flow[i][1] * (temperatureData[i][1] + 273)) / (293 * pressureData[i][1])
              }
            } else {
              flow = 0
            }
            flow = typeof flow === 'string' ? flow : flow.toFixed(5)
            this.pointsDataLengthMap.gkll = Math.max(this.pointsDataLengthMap.gkll || 0, flow.length)
            flows.push([
              time,
              flow
            ])
          }
        } else {
          less = 0
          const { data } = await getDeviceHistoryData({
            deviceId: this.flowForm.pid,
            pointCode: this.flowForm.pPointCode,
            startTime: +this.outerDateValue[0],
            endTime: +this.outerDateValue[1] + 24 * 3600000 - 1
          })
          if (data.length) {
            let targetTime, code = this.flowForm.pPointCode
            for (let i = 0; i < this.historyMap.time.length; i++) {
              targetTime = this.historyMap.time[i][0]
              if (this.historyMap.time[i][1] !== '-') {
                if (less < data.length - 1) {
                  for (let j = less; j < data.length; j++) {
                    time = parseInt(new Date(data[j].time) / 1000) * 1000
                    if (time > targetTime) {
                      less = j
                      if (j > 0) {
                        gap1 = Math.abs(targetTime - data[j - 1].time)
                        gap2 = Math.abs(targetTime - time)
                        pressureData.push([
                          targetTime,
                          gap1 < gap2 ? data[j - 1][code] : data[j][code]
                        ])
                      } else {
                        pressureData.push([
                          targetTime,
                          data[less][code]
                        ])
                      }
                      break
                    } else if (time == targetTime) {
                      less = j
                      pressureData.push([
                        targetTime,
                        data[less][code]
                      ])
                      break
                    }
                  }
                } else {
                  pressureData.push([
                    this.historyMap.time[i][0],
                    data[less][code]
                  ])
                }
                this.pointsDataLengthMap.gkyl = Math.max(this.pointsDataLengthMap.gkyl || 0, (pressureData[i][1] + '').length)
                if (isFlow) {
                  if (pressureData[i][1]) {
                    flow = (0.101325 * this.historyMap.flow[i][1] * (temperatureData[i][1] + 273)) / (293 * pressureData[i][1])
                  } else {
                    flow = 0
                  }
                  flow = flow.toFixed(5)
                  flows.push([
                    this.historyMap.time[i][0],
                    flow
                  ])
                } else {
                  flows.push([
                    this.historyMap.time[i][0],
                    '-'
                  ])
                }
              } else {
                pressureData.push([
                  targetTime,
                  "-"
                ])
                if (isFlow) {
                  flow = '-'
                }
                flows.push([
                  targetTime,
                  flow
                ])
              }
            }
          } else {
            for (let i = 0; i < this.historyMap.time.length; i++) {
              pressureData.push([
                this.historyMap.time[i][0],
                '-'
              ])
              flows.push([
                this.historyMap.time[i][0],
                '-'
              ])
            }
            this.pointsDataLengthMap.gkyl = 1
            isFlow = false
          }
        }
        this.pointsDataLengthMap.gkll = isFlow ? 7 : 1
        this.gkll = {
          gkwd: {
            code: this.deviceList.find(d => d.id === this.flowForm.id).code,
            data: temperatureData
          },
          gkyl: {
            code: this.deviceList.find(d => d.id === this.flowForm.id).code,
            data: pressureData
          },
          gkll: {
            code: 'gkll',
            data: flows
          }
        }
        console.log(this.gkll);
      } catch(e) {
        console.log(e)
      } finally {
        this.isFlowLoading = false
        return true
      }
    },
    async selectDeviceForFlow(d) {
      if (!d.id) {
        return
      }
      if (d.id != this.flowForm.id) {
        this.gkll = undefined
      }
      this.flowForm.id = d.id
      this.flowForm.protocolCode = d.protocolCode
      const { data } = await getProtocol(d.protocolCode)
      this.flowPointsList = data.points.filter(d => d.dataWrite !== 2).map(item => {
        item.zh = item.name
        item.en = item.details?.find(d => d.locale === 'en-US')?.name
        if (!item.en) {
          item.en = item.zh
        }
        return item
      }).filter(p => p.name.includes('温度'))
    },
    async selectPDeviceForFlow(d) {
      if (!d.id) {
        return
      }
      if (d.id != this.flowForm.pid) {
        this.gkll = undefined
      }
      this.flowForm.pid = d.id
      this.flowForm.pProtocolCode = d.protocolCode
      const { data } = await getProtocol(d.protocolCode)
      this.pressurePointsList = data.points.filter(d => d.dataWrite !== 2).map(item => {
        item.zh = item.name
        item.en = item.details?.find(d => d.locale === 'en-US')?.name
        if (!item.en) {
          item.en = item.zh
        }
        return item
      }).filter(p => p.name.includes('压力'))
    },
    handleExtraChange(e) {
      // this.isExtrachecked = e.target.checked
      // this.drawSummaryChart()
      if (e.target.checked && ((!this.flowForm.tMock && !this.flowForm.pointCode) || (!this.flowForm.pMock && !this.flowForm.pPointCode))) {
        this.isExtrachecked = false
        this.$refs.extra.value = this.$refs.extra.checked = this.isExtrachecked
        if (!this.extraFlowShow) {
          this.extraFlowShow = true
        }
        const LKEY = `${this.$route.query.stationCode} ${this.device.code}FC`
        localStorage.setItem(LKEY, this.isExtrachecked)
        return this.$message.warn('请配置完整参数')
      } else {
        this.isExtrachecked = e.target.checked
        const LKEY = `${this.$route.query.stationCode} ${this.device.code}FC`
        localStorage.setItem(LKEY, e.target.checked)
      }
      this.drawSummaryChart()
    },
    clearGkll() {
      this.gkll = undefined
    },
    connectWebSocket() {
      if(this.webSocket) {
        this.webSocket.close()
      }

      const gk_temp = {}, deviceCodes = []
      let time, gkwd, gkyl, gkll, ll, code
      for (let k in this.gkll) {
        code = this.gkll[k].code
        gk_temp[k] = {
          code,
          data: []
        }
        if (code !== 'gkll') {
          deviceCodes.push(code)
        }
      }
      deviceCodes.push(this.device.code)

      const authorization = 'Bearer ' + JSON.parse(localStorage.getItem('token'))
      this.webSocket = new WebSocket(`wss://ygk.deman.cn:9006/ws/device/group/${this.stationId}?token=${authorization}`)

      this.webSocket.onopen = () => {
        this.webSocket.send(deviceCodes)
      }

      this.webSocket.onmessage = ({ data }) => {
        if (data === this.stationCode) {
          this.isConnected = true
          return
        }

        const record = JSON.parse(data)
        for (let k in gk_temp) {
          if (record.device_code === k) {
            gk_temp[k].push(record[k])
          }
        }
        if (record.device_code === this.device.code) {
          time = +new Date()
          for (let k in this.historyMap) {
            this.historyMap[k].push([
              time,
              (record[k] || record[k] == 0) ? record[k] : '-'
            ])
          }
          ll = record.flow
          if (this.gkll) {
            if (this.flowForm.tMock) {
              gkwd = this.flowForm.tValue
            } else {
              if (gk_temp.gkwd.length) {
                gkwd = gk_temp.gkwd.at(-1)
              } else {
                gkwd = '-'
              }
            }
            this.gkll.gkwd.data.push([
              time,
              gkwd
            ])
  
            if (this.flowForm.pMock) {
              gkyl = this.flowForm.pValue
            } else {
              if (gk_temp.gkyl.length) {
                gkyl = gk_temp.gkyl.at(-1)
              } else {
                gkyl = '-'
              }
            }
            this.gkll.gkyl.data.push([
              time,
              gkyl
            ])
  
            if (gkwd === '-' || gkyl === '-') {
              gkll = '-'
            } else {
              gkll = ((0.101325 * +(ll || 0) * (+(gkwd || 0) + 273)) / (293 * +(gkyl || 0))).toFixed(5)
            }
            this.gkll.gkll.data.push([
              time,
              gkll
            ])
          }

          if (+this.outerDateValue[1] + 24 * 3600000 - 1 > +new Date()) {
            this.drawPointsCharts()
            this.drawSummaryChart()
          }
          
        }
      }
    },
    checkWebSocketConnecting() {
      this.hbpSenderTimer = setInterval(() => {
        if (this.webSocket && !this.connecting) {
          try {
            this.webSocket.send(this.stationCode)
          } catch(e) {
            console.log(e)
          } finally {
            this.isConnected = false
            this.timeout1 = setTimeout(() => {
              if (!this.isConnected) {
                if (this.webSocket && !this.connecting) {
                  this.webSocket.close()
                  this.webSocket = null
                }
                this.reconnect()
              }
            }, 3000)
          }
        } else if (!this.webSocket && !this.connecting) {
          this.reconnect()
        }
      }, 10000)
    },
    showPrompt () {
      this.promptVisible = true
    },
    reconnect() {
      if (!this.connecting) {
        this.connecting = true
        this.connectWebSocket()
        this.timeout2 = setTimeout(() => {
          this.connecting = false
        }, 1000)
      }
    },
    handleDataShowModalChange() {
      this.render()
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    async setLoadRateInfoAndShowLoadRateModal() {
      this.loadRateModalButtonLoading = true
      try {
        this.loadRateDateRange = [
          new Date(new Date().setHours(0, 0, 0, 0)),
          new Date()
        ]
        await this.getMemo()
        if (this.memo[1][this.device.id]) {
          for (let key in this.loadRateForm) {
            this.loadRateForm[key] = this.memo[1][this.device.id][this.loadRateType[0]][key] || ''
          }
          if (this.loadRateType[0] === 'IndustrialFrequency') {
            this.selectedDevice = this.memo[1][this.device.id].IndustrialFrequency.device || +this.device.id
          }
          if (this.loadRateType[0] === 'variableFrequency') {
            this.selectedDevices = this.memo[1][this.device.id].variableFrequency.devices || +this.device.id
          }
        } else {
          this.selectedDevices = +this.device.id
          this.selectedDevice = +this.device.id
        }
        this.loadRateForm.stanbyPower = this.loadRateForm.stanbyPower || '1'
        this.deviceList = this.sideMenus.find(s => s.key === 'DB').children
        this.loadRateShow = true
      } catch(e) {
        console.log(e)
      } finally {
        this.loadRateModalButtonLoading = false
      }
    },
    addParamter() {
      this.parameters.push({
        id: nanoid(),
        deviceId: undefined,
        points: [],
        pointCode: []
      })
    },
    closeLoadRateModalAndClearInfo() {
      this.loadRateShow = false
      this.loadRateForm.unloadingPower = ''
      this.loadRateForm.fullLoadPower = ''
      this.loadRateForm.stanbyPower = '1'
      this.selectedDevices = undefined
      this.selectedDevice = undefined
      this.avgPower = this.electricityMeterAccumulation = this.maxPower = this.minPower = this.loadingRate = this.capacityRate = this.dataCount = this.loadCount = this.unloadCount = 0
    },
    async selectDevice(v, i) {
      this.parameters[i].deviceId = v
      const { data } = await getProtocol(this.$route.query.pc, this.$route.query.pc)
      this.parameters[i].points = data.points.filter(d => d.dataWrite !== 2)
    },
    deleteParameter(i) {
      this.parameters.splice(i, 1)
    },
    async getLoadRate() {
      if (!this.loadRateDateRange) {
        return this.$message.warn(this.$t('device.selectDate'))
      }
      if ((this.loadRateDateRange[1] - this.loadRateDateRange[0]) / 1000 / 60 / 60 / 24 > 31) {
        this.isGettingLoadRateButtonLoading = false
        return this.$message.warn(this.$t('messages.moreThanOneMonth'))
      }
      let flag
      this.$refs.loadRateForm.validate(valid => {
        flag = valid
      })

      if (!flag) return this.$message.warn(this.$t('device.compeleteInfo'))
      if ((this.loadRateType[0] === 'variableFrequency' && !this.selectedDevices) || (this.loadRateType[0] === 'IndustrialFrequency' && !this.selectedDevice)) return this.$message.warn(this.$t('messages.selectDevice'))

      this.isGettingLoadRateButtonLoading = true
      const promises = []
      const result = {}
      let sd = this.loadRateType[0] === 'IndustrialFrequency' ? [this.selectedDevice] : this.selectedDevices
      sd.forEach(p => {
        result[p] = {}
        promises.push(new Promise(async (resolve, reject) => {
          try {
            const { data } = await getDeviceHistoryData({
              deviceId: p,
              pointCode: 'power,total_electric',
              startTime: +this.loadRateDateRange[0],
              endTime: +this.loadRateDateRange[1]
            })
            data.forEach(d => {
              result[p][moment(+new Date(d.time)).format('YYYY-MM-DD HH:mm:ss')] = d
            })
            resolve()
          } catch(e) {
            console.log(p, e)
            reject()
          }
        }))
      })

      try {
        await Promise.all(promises)
        let basicDeviceId = this.device.id
        basicDeviceId = result[basicDeviceId] ? basicDeviceId : (sd[0] || 0)
  
        let exited, power = 0, total_electric = 0
        const data = []
        for (let time in (result[basicDeviceId] || {})) {
          exited = true
          power = 0
          total_electric = 0
          for (let key in result) {
            if (result[key][time]) {
              power += result[key][time].power
              total_electric += result[key][time].total_electric
            } else {
              exited = false
            }
          }
          if (exited) {
            data.push({
              time,
              power,
              total_electric
            })
          }
        }

        let count = data.length, avgPower = 0, summaryPower = 0, minPower = Infinity, maxPower = -Infinity, loadRateCount = 0, electricityMeterAccumulation = 0, eStart = 0, eEnd = count - 1, item, realCount = 0

        for (let i = 0; i < count; i++) {
          item = data[i]
          if (item.power > +this.loadRateForm.stanbyPower) {
            realCount++
            summaryPower += item.power
            if (item.total_electric) {
              eStart = Math.min(eStart, i)
              eEnd = Math.max(eEnd, i)
            }
            minPower = Math.min(minPower, item.power)
            maxPower = Math.max(maxPower, item.power)
            if (item.power > +this.loadRateForm.unloadingPower) {
              loadRateCount++
            }
          }
        }

        if (!data.length) {
          this.$message.warn(this.$t('common.nd'))
          throw new Error("暂无数据")
        }

        this.dataCount = realCount
        this.loadCount = loadRateCount
        this.unloadCount = realCount - loadRateCount
        avgPower = (summaryPower / realCount).toFixed(1)
        if (!realCount) {
          electricityMeterAccumulation = 0
          this.avgPower = 0
          this.maxPower = 0
          this.minPower = 0
          this.loadingRate = 0
          this.capacityRate = 0
          this.unloadRate = 0
          return this.$message.error(this.$t('common.nd'))
        }
        electricityMeterAccumulation = (data[eEnd].total_electric - data[eStart].total_electric).toFixed(1)
        this.avgPower = avgPower
        this.electricityMeterAccumulation = electricityMeterAccumulation
        this.maxPower = maxPower.toFixed(1)
        this.minPower = minPower.toFixed(1)
        this.loadingRate = (loadRateCount / realCount * 100).toFixed(1)
        this.unloadRate = (100 - this.loadingRate).toFixed(1)
        this.capacityRate = (avgPower / this.loadRateForm.fullLoadPower * 100).toFixed(1)
      } catch(e) {
        console.log(e)
        this.avgPower = this.electricityMeterAccumulation = this.maxPower = this.minPower = this.loadingRate = this.capacityRate = 0
      } finally {
        this.isGettingLoadRateButtonLoading = false
      }
    },
    validateDate(a) {
      if ((a[1] - a[0]) / 1000 / 60 / 60 / 24 > 31) {
        this.isGettingLoadRateButtonLoading = false
        return this.$message.warn(this.$t('messages.moreThanOneMonth'))
      }
    },
    async saveDevices() {
      if (this.memo[1][this.device.id]) {
        this.isDeviceSaving = true
        if (this.loadRateType[0] === 'IndustrialFrequency') {
          this.memo[1][this.device.id].IndustrialFrequency.device = this.selectedDevice
        }
        if (this.loadRateType[0] === 'variableFrequency') {
          this.memo[1][this.device.id].variableFrequency.devices = this.selectedDevices
        }

        try {
          const { message } = await u(this.memo)
          this.$message.success(message)
        } catch(e) {
          console.log(e)
        } finally {
          this.isDeviceSaving = false
        }
      }
    },
    closeParameterSetting() {
      this.isParameterSettingVisible = false
    },
    addParameter() {
      this.parametersAxisSettings.push({
        id: nanoid(),
        selectedPoints: [],
        min: "",
        max: ""
      })
    },
    deleteParameterSetting(i) {
      this.parametersAxisSettings.splice(i, 1)
    },
    confirmAxisSetting() {
      const map = {}

      let p, s
      for (let i = 0; i < this.parametersAxisSettings.length; i++) {
        p = this.parametersAxisSettings[i]

        if (p.selectedPoints && p.selectedPoints.length) {
          for (let j = 0; j < p.selectedPoints.length; j++) {
            s = p.selectedPoints[j]

            map[s] = {}

            if (!isNaN(+p.min)) {
              map[s].min = +p.min
            }

            if (!isNaN(+p.max)) {
              map[s].max = +p.max
            }
          }
        }
      }

      this.axisMap = map
      this.closeParameterSetting()
      this.drawSummaryChart()
    }
  }
}
</script>

<style lang="less" scoped>
ul, li {
  margin: 0;
  padding: 0;
}
li {
  list-style: none;
}
.ant-layout {
  background-color: #2f3d4f !important;
  overflow: auto;
}
.ant-layout::-webkit-scrollbar {
  width: 8px;
  border-radius: 4px;
}
.ant-layout::-webkit-scrollbar-track {
  width: 8px;
  border-radius: 4px;
}
.ant-layout::-webkit-scrollbar-thumb {
  width: 8px;
  background-color: #4961a3;
  border-radius: 4px;
}
.ant-layout-has-sider {
  margin: 20px;
}
.ant-layout-content {
  height: 760px;
}
label {
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  margin-left: 10px;
  color: #fff;
}
.icon {
  width: 8px;
  height: 70%;
  border-radius: 4px;
  top: 50%;
  transform: translateY(-50%);
}
/deep/ .ant-calendar-picker-input.ant-input {
  background-color: #2f3d4f;
}
/deep/ .el-input__inner {
  height: 40px;
  background-color: unset;
  color: #fff;
}
/deep/ .el-date-editor .el-range-separator {
  line-height: 30px;
}
/deep/ .el-date-editor .el-range__icon {
  position: absolute;
  top: 1px;
}
.img {
  float: left;
  width: 100px;
  height: 80px;
  img {
    width: 100%;
    height: 100%;
  }
}
.input {
  margin-left: 125px;
  margin-bottom: 10px;
}
.header {
  position: relative;
  overflow: hidden;
  button:not(.ant-switch) {
    background-color: #00adff;
    border-radius: 10px;
    border: none;
    height: 40px;
    width: auto;
    padding: 0 10px;
    margin-left: 15px;
    line-height: 40px;
    text-align: center;
    color: #edfaff;
    cursor: pointer;
  }
  .exportData {
    margin-left: 115px;
  }
  .pointsList {
    width: calc(100% - 25px);
    float: left;
    margin-top: 20px;
    margin-left: 25px;
    padding: 0;
    li {
      width: unset;
      list-style: none;
      float: left;
      padding: 0 10px 0 3px;
      border: 1px solid #1890ff;
      color: #118bcd;
      display: flex;
      &:hover {
        background-color: #00adff;
        color: #edfaff;
      }
      label {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        white-space: nowrap;
        cursor: pointer;
      }
      input[type^="checkbox"] {
        width: 18px;
        height: 18px;
        border: none;
        outline: none;
        vertical-align: bottom;
      }
    }
  }
}
.container {
  width: 100%;
  height: 660px;
  overflow: auto;
}
.container::-webkit-scrollbar {
  width: 6px;
  background-color: #ccc;
  border-radius: 3px;
}
.container::-webkit-scrollbar-track {
  width: 6px;
  background-color: #ccc;
  border-radius: 3px;
}
.container::-webkit-scrollbar-thumb {
  width: 6px;
  background-color: #4961a3;
  border-radius: 3px;
}
.charts {
  padding: 20px;
  li {
    position: relative;
    list-style: none;
    width: 100%;
    height: 300px;
    padding: 20px;
    border: 1px solid #ccc;
    h3 {
      color: #a5abb3;
    }
    div {
      position: absolute;
      top: 30px;
      left: 45px;
      padding: 0;
      z-index: 1;
    }
  }
}
.ant-spin-spinning {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.stationName {
  height: auto;
  background-color: #001529;
  margin: 0;
  padding: 0;
  color: #fff;
  line-height: 40px;
  font-size: 18px;
  padding-left: 24px;
}
.mask {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
  .container {
    width: 1600px;
    min-height: 600px;
    height: auto;
    max-height: 960px;
    overflow: auto;
    background-color: #2f3d4f;
    position: relative;
    padding: 40px;
    i {
      font-size: 30px;
      position: absolute;
      top: 10px;
      right: 10px;
      color: #fff;
      cursor: pointer;
    }
  }
  .box {
    width: 100%;
    height: auto;
    margin-bottom: 10px;
  }
  .avgConsumption .container,
  .range .container {
    height: 800px;
  }
  .chart {
    width: 100%;
    height: 620px;
    border: 1px solid #ccc;
  }
  .form {
    width: 90%;
    div {
      margin-bottom: 10px;
    }
  }
  #deviceComparation {
    width: 100%;
    height: auto;
    height: 600px;
    overflow-y: auto;
    overflow-x: hidden;
    margin-top: 20px;
    border: 1px solid #ccc;
  }
  /deep/ .ant-select-selection--multiple,
  /deep/ .ant-select-selection__rendered {
    min-height: 40px;
  }
  /deep/ .ant-input {
    background-color: unset;
  }
  /deep/ .ant-select-selection--single{
    height: 40px;
  }
  /deep/ .ant-select-selection-selected-value {
    line-height: 40px;
  }
}
/deep/ .ant-form-item-control .ant-calendar-picker-input {
  background-color: unset;
}
.mask {
  /deep/ .el-icon-date:before {
    position: absolute;
    top: 1px;
    left: 5px;
  }
  /deep/ .el-date-editor--date .el-input__suffix {
    top: -4px;
  }
}
.statistics ul li {
  width: 100%;
  margin-bottom: 10px;
  display: flex;
}
.time li {
  width: 30%;
  float: left;
  margin-bottom: 10px;
}
.rate {
  height: 300;
  .container {
    width: 670px;
    min-height: unset;
  }
  /deep/ .el-icon-time {
    top: 2px;
    left: 3px;
  }
}
.range .chart {
  width: 75%;
  border: none;
  border-left: 1px solid #ccc;
}
.range .container {
  height: 800px;
}
.range {
  width: 1600px;
  height: 500px;
  background-color: unset;
  z-index: 1;
}
.range .wrapper {
  width: 100%;
  height: 100%;
}
.range ul {
  width: 100%;
}
.range .formList {
  width: 20%;
  padding-right: 20px;
  margin-bottom: 10px;
  float: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.range .content {
  width: 100%;
  height: 500px;
  border: 1px solid #ccc;
  display: flex;
  justify-content: space-between;
}
.range .wrapper {
  cursor: move;
}
.range .container {
  z-index: 100;
  border: 1px solid #ccc;
}
.range .head,
.range .box {
  cursor: default;
}
.range .detail,
.range .chart {
  height: 100%;
}
.range .detail {
  width: 24%;
  padding: 20px;
  text-align: center;
}
.range .detail h3 {
  color: #fff;
  font-size: 18px;
}
.range .detail ul {
  padding: 10px 30px;
  border: 1px solid #ccc;
  margin-bottom: 10px;
  overflow: auto;
  max-height: calc(100% - 65px);
}
.range .detail ul::-webkit-scrollbar {
  width: 8px;
  border-radius: 4px;
}
.range .detail ul::-webkit-scrollbar-track {
  width: 8px;
  border-radius: 4px;
}
.range .detail ul::-webkit-scrollbar-thumb {
  width: 8px;
  background-color: #4961a3;
  border-radius: 4px;
}
.range .detail ul li {
  padding: 10px 0;
  font-size: 16px;
  color: #fff;
  display: flex;
  justify-content: space-between;
}
.range .chart {
  width: 75%;
  border: none;
  border-left: 1px solid #ccc;
}
.statistics .dataList {
  width: 110%;
  float: left;
  margin-top: 20px;
  margin-left: 25px;
  padding: 0 !important;
  background-color: #2f3d4f;
  label {
    width: 100%;
    height: 30px;
    padding: 0 10px 0 3px;
    border: 1px solid #1890ff;
    color: #118bcd;
    display: flex;
    align-items: center;
    &:hover {
      background-color: #00adff;
      color: #edfaff;
    }
  }
}
.statistics .dataList li {
  width: unset;
  float: left;
  list-style: none;
  float: left;
  // padding: 0 10px 0 3px;
  // border: 1px solid #1890ff;
  // color: #118bcd;
  // &:hover {
  //   background-color: #00adff;
  //   color: #edfaff;
  // }
}
.line {
  color: #fff;
}
.statistics ul li {
  width: 100%;
  margin-bottom: 10px;
  display: flex;
}
li label {
  width: 30px;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  white-space: nowrap;
}
input[type^="checkbox"] {
  width: 18px;
  height: 18px;
  border: none;
  outline: none;
  vertical-align: bottom;
  cursor: pointer;
}
.ant-modal div[aria-hidden="true"] {
  display: none !important;
}
.prompt {
  position: absolute;
  z-index: 10;
  top: 60px;
  right: 20px;
  background-color: #001529;
}
.prompt > div {
  display: flex;
  justify-content: space-between;
  padding: 0 15px;
}
.prompt .box {
  width: 8px;
  height: 20px;
  border-radius: 4px;
  display: flex;
}
.prompt .head {
  right: 12px;
  height: 30px;
  position: absolute;
}
.prompt .icon {
  font-size: 18px;
  color: #fff;
  right: 0;
  cursor: pointer;
}
.prompt .title {
  height: 40px;
  color: #fff;
  font-size: 20px;
}
/deep/ canvas {
  z-index: 1;
}
#summary {
  overflow: hidden;
}
.loadRate {
  .container {
    width: 1500px;
    height: 700px;
  }
  /deep/ .ant-form label {
    font-size: 16px;
    color: #fff;
  }
  /deep/ .ant-calendar-range-picker-separator {
    color: #fff;
  }
  /deep/ .ant-calendar-range-picker-input {
    color: #fff;
  }
  /deep/ .anticon-close-circle {
    background-color: #2f3d4f;
    color: #ccc;
  }
  /deep/ .ant-menu-horizontal {
    border-bottom: none;
  }
  .container {
    display: flex;
    flex-direction: column;
  }
  .box {
    display: flex;
    justify-content: space-between;
    flex: 1;
    .flex {
      width: 97%;
      display: flex;
      align-items: center;
      // justify-content: space-between;
    }
    /deep/ .el-range-input {
      margin-left: 20px;
    }
    .right {
      width: 30%;
      border: 1px solid #ccc;
      padding: 20px;
      padding-top: 10px;
      font-size: 16px;
      color: #fff;
      height: 500px;
    }
    .left {
      width: 68%;
      height: 500px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      > div {
        border: 1px solid #ccc;
        padding: 0 20px 10px;
      }
      .form {
        height: 60%;
        width: 100%;
      }
      .result {
        height: 36%;
        .data {
          color: #fff;
          font-size: 16px;
        }
        .content {
          div {
            float: left;
            width: 33%;
          }
        }
      }
      .paramGroups {
        height: 40%;
        overflow: auto;
        padding-right: 15px;
        margin-top: 8px;
        /deep/ .ant-radio-wrapper {
          margin-left: 0 !important;
        }
        .paramGroup {
          width: 30%;
          float: left;
          display: flex;
          margin-right: 14px;
          align-items: center;
          // justify-content: space-between;
          color: #fff;
          label {
            margin-left: 10px;
          }
          /deep/ .ant-select-selection--multiple {
            height: 32px;
          }
          /deep/ .ant-select-selection--multiple .ant-select-selection__rendered > ul > li {
            height: 24px !important;
            line-height: 24px !important;
          }
          
        }
        /deep/ .ant-checkbox-wrapper {
          margin-bottom: 0 !important;
        }
        &::-webkit-scrollbar {
          width: 8px;
          // background-color: #ccc;
          border-radius: 4px;
        }
        &::-webkit-scrollbar-track {
          width: 8px;
          // background-color: #ccc;
          border-radius: 4px;
        }
        &::-webkit-scrollbar-thumb {
          width: 8px;
          background-color: #4961A3;
          border-radius: 4px;
        }
        /deep/ .ant-select-focused {
          color: #fff;
        }
      }
    }
  }
}
.axis {
  .wrapper {
    width: 900px;
    height: 500px;
    position: relative;

    .container {
      width: 100%;
      height: 100%;
      min-height: unset;
      max-height: unset;
      padding: 40px 30px;

      .content {
        width: 100%;
        height: 100%;
        
        .parameters {
          width: 100%;
          height: calc(100% - 72px);
          overflow: auto;

          &::-webkit-scrollbar {
            width: 8px;
            // background-color: #ccc;
            border-radius: 4px;
          }
          &::-webkit-scrollbar-track {
            width: 8px;
            // background-color: #ccc;
            border-radius: 4px;
          }
          &::-webkit-scrollbar-thumb {
            width: 8px;
            background-color: #4961A3;
            border-radius: 4px;
          }

          li {
            position: relative;

            i {
              top: 50%;
              right: 0;
              transform: translateY(-50%);
              width: 24px;
              height: 30px;
              font-size: 24px;
            }
          }
        }
      }
    }

    footer {
      width: 100%;
      height: 60px;
      position: absolute;
      bottom: 0;

      .buttons {
        position: absolute;
        top: 50%;
        right: 18px;
        transform: translateY(-50%);
      }
    }
  }
}
/deep/ .ant-input {
  background-color: #2f3d4f;
  color: #fff;
}

/deep/ .ant-select-selection--multiple {
  min-height: unset !important;
  height: auto;
  color: #fff;

  .ant-select-selection__rendered {
    min-height: unset !important;
  }
}

.statistic .mask /deep/ .ant-select-selection--multiple > ul > li, .statistic /deep/ .ant-select-selection--multiple .ant-select-selection__rendered > ul > li {
  height: 24px !important;
  line-height: 24px !important;
}

.removeModal /deep/ .ant-calendar-range-picker-input {
  color: #333;
}

.explain {
  position: absolute;
  bottom: 0;
  left: 0;
  color: #aaa;
  transform: translateY(100%);
}
</style>